import React from 'react';
import { LabelSub } from '../componentes_generales/componentes_formulario/labels/';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol, ContainerEdit } from '../componentes_generales/componentes_formulario/contenedores/';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import { LabelForm, LabelCabecera } from '../componentes_generales/componentes_formulario/labels/';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import styled from 'styled-components';
import  global_axios  from '../../funciones_globales/interaccionapi';
import { cargarCatalogosGenericoAsync, cargarParametros, cargarCatalogos_Otros, cargarCatalogos } from '../../funciones_globales/catalogos';
import {  reduxForm , formValueSelector  } from 'redux-form';
import { connect } from 'react-redux';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';
import { cargar_cobranza, cargar_ValoresIniciales } from '../../actions/caja/act_caja01';
import { validarFechaMomentEnFormatoString, validarFechaCierreCartera } from '../../funciones_globales/utils';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { formatearFechaMoment_a_StringFormatoReporte } from '../../funciones_globales/format';
import moment from 'moment';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import '../componentes_generales/componentes_formulario/contenedores/flexbox.css';
import ModalResponsive from '../componentes_generales/componentes_formulario/modals/modalresponsive';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import { formatearLabel } from '../../funciones_globales/format';
import { validarFechaTransaccionSeleccionada } from '../../funciones_globales/utils';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { formatearFechaMoment_a_String } from '../../funciones_globales/format';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { formatearNumeroDecimal } from '../../funciones_globales/format';
// import Tooltip from 'rc-tooltip';
// import 'rc-tooltip/assets/bootstrap.css';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

const BotonLink = styled.button`
    color: #337ab7;
    border: none;
    border-radius: 0;
    font-weight: normal;
    background-color: transparent;
    border-color: transparent;
    &:hover {
        border-color: transparent;        
        text-decoration: underline;
    };
    &:focus {
        border-color: transparent;        
    };
    &:active {
        border-color: transparent;        
    };
    font-size: 9px;
    font-weight: 600;
    margin: 0px;
`;

const ContenedorModal = styled.div`
    margin-top: 20px;
    height: 75px;
    width: 350px;
`;

const ContenedorGrid = styled.div`
    margin-top: ${props => props.margen_arriba?props.margen_arriba:0}px;
    margin-bottom: ${props => props.margen_abajo?props.margen_abajo:1}px;
    display: ${props => props.isInvisible?'none':'block'};
    text-align: ${props => props.align?props.align:'left'};
    @media(min-width: 900px){
        padding-left: ${props => props.margen_izq? props.margen_izq: 15}px;
        padding-right: ${props => props.margen_der? props.margen_der: 15}px;
        width: ${props => props.ancho? props.ancho: 100}%;
    }
    
`;


class FormCaja01 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            //ArraysCambios
            changesVR: [], //Array que guarda la auditoria de los cambios sobre VR que necesitan aprobacion
            
            //MODAL
            editarValoresRecibidos: false,
            //isOpenSuper: false,
            isOpenModalRet: false,

           //PARAMETROS
            empresa: null,
            paramDiasRetroDoc: null,
            parametros_che: null,
            parametros_ret: [], //Soporte de descuadre entre retenciones

            //Inputs
            userInput: "",
            passInput: "",
            usuario_aprobador: '',

            recaudador_sel: null,
            cliente_sel: null,
            vendedor_sel: null,

            //Catalogos
            parametrosImpRetencion: [],
            parametrosImpRetIvaCli: [],  //Se obtiene el porcentaje de RET IVA SEGÚN EL TIPO DE PERSONA

            //ReactSELECT
            tipoRetencion: [],
            catalogoImpuestos: [],
            impuestos_sel: null,
            catBancos: [],
            catBancos_sel: null,
            catBancosRow_sel: null,          

            doc_pendientes: [],
            cheques_usados: [],
            docs_porPeticion: [],

            //Botones --desactivados default
            recaudador: false,
            cartera: false,
            cobro: false,

            boton_distribuir: true,
            boton_aplicar_distribucion: true,

            //MovimientoCaja
            secuencial_caja: 0,
            
            //Status
            super: false,
            cheq_alert: false,
            exist_chq_protestados: false,
            sobre_pago: false,
            recibo_estado: 'P',
            operacion_incompleta: false,
            efectivo_alert: false,

            Error_distribucion_recibida: false, //ERROR EN LA CREACION DE DP NO DEJAR AVANZAR A CREAR DISTRIBUCION FINAL;

            //Cabecera
            c_total_recibo: 0.00,

            //Calculos
            total_recibidos: 0.00,
            total_retencion: 0.00,
            total_aplicacion: 0.00,
            total_ntacredito: 0.00,
            diferenciaVA: 0.00,

            total_DISPG: 0.00,

            //label
            labelEstado: '',

            //Documentos Pendientes
            total_saldo_recibido_DP: 0.00,
            total_ret_DP: 0.00,
            total_aplicado_DP: 0.00,            

            //RETIvaCliActiva
            retIvaCliSel: null,

            //fechaProceso
            readOnly: true,
            fechaCaja: null,

            //Fecha Recibo
            fechaRecibo: null,

            //INPUT TEXT
            observacion_vendedor: '',
            observacion_supervisor: '',

            //TOTAL RETENCION DE FACTURAS TRAIDAS
            total_retencion_fact_traidas: 0,

            recibo: '',
            grid_valores_recibidos: [],
            grid_valores_aplicados: [],
            grid_docs_pendientes: [],
            grid_distribucionpago: [],
            grid_notas_credito:[],
            columnDefs_VR:         [
                                        {   header: "",
                                            children:   [{  header: "N°",
                                                            field: "secuencia",
                                                            width: 30,
                                                            type: "num_entero"                                                 
                                                        },
                                                        {   header: "Forma de pg.",
                                                            field: "DescripcionPago",
                                                            width: 110,
                                                            type: "string"                                                 
                                                        },
                                                        {   header: "Banco",
                                                            field: "Banco",
                                                            width: 99,
                                                            type: "string"                                                 
                                                        },
                                                        {   header: "Cuenta",
                                                            field: "Cuenta",
                                                            width: 73,
                                                            type: "num_entero_edit",
                                                            editable: false                                                                               
                                                        },
                                                        {   header: "Doc.",
                                                            field: "Cheque",
                                                            width: 40,
                                                            type: "num_entero_edit",
                                                            editable: false                                                                               
                                                        },
                                                        {   header: "Emisor",
                                                            field: "Emisor",
                                                            width: 138,
                                                            type: "string",                                            
                                                        },
                                                        {   header: "Fec.Dep.",
                                                            field: "FechaDeposito",
                                                            width: 70,
                                                            type: "string",
                                                            editable: true                                                                         
                                                        },
                                                        {   header: "Fec.Ven.",
                                                            field: "Vencimiento_cheq",
                                                            width: 70,
                                                            type: "string",
                                                            editable: true                                                                         
                                                        },
                                                        {   header: "Valor",
                                                            field: "ValorRecaudado",
                                                            width: 50,
                                                            type: "num_decimal_edit",
                                                            editable: false                                             
                                                        },
                                                        {   header: "Fac./Ret.",
                                                            field: "fac_ret",
                                                            width: 90,
                                                            type: "string",
                                                            editable: true                                               
                                                        }],
                                        },
                                        {   header: "Ret. Fuente",
                                            children:   [{  header: "Bienes",
                                                            field: "retFteBienes",//ret_fte
                                                            width: 50,
                                                            type: "num_decimal_edit",
                                                            editable: true                                               
                                                        },
                                                        {  header: "Serv.",
                                                            field: "retFteServicio",//ret_iva
                                                            width: 50,
                                                            type: "num_decimal_edit",
                                                            editable: true                                               
                                                        }],
                                        },
                                        {   header: "Ret. Iva",
                                            children:   [{  header: "Bienes",
                                                            field: "retIvaBienes",
                                                            width: 50,
                                                            type: "num_decimal_edit",
                                                            editable: true                                               
                                                        },
                                                        {  header: "Serv.",
                                                            field: "retIvaServicio",
                                                            width: 50,
                                                            type: "num_decimal_edit",
                                                            editable: true                                               
                                                        }],
                                        }],
            columnDefs_VA:         [    
                                        {   header: "Tipo",
                                            field: "Tipo_Transaccion",
                                            width: 36,
                                            type: "string"                                                 
                                        },
                                        {   header: "Nro. Doc.",
                                            field: "Movimiento",
                                            width: 90,
                                            type: "string"                                                 
                                        },
                                        {   header: "Valor",
                                            field: "valor",
                                            width: 50,
                                            type: "num_decimal",                         
                                        },
                                        {   header: "Saldo",
                                            field: "saldo",
                                            width: 50,
                                            type: "num_decimal"                                                                      
                                        },
                                    ],
            columnDefs_DP:         [   
                                        {   header: "Tipo",
                                            field: "Tipo_Transaccion",
                                            width: 40,
                                            type: "string"                                                 
                                        },
                                        {   header: "Nro. Doc.",
                                            field: "Movimiento",
                                            width: 165,
                                            type: "string"                                                 
                                        },
                                        {   header: "Fecha",
                                            field: "fecha",
                                            width: 85,
                                            type: "fecha",                                                
                                        },
                                        {   header: "Val. Original.",
                                            field: "valor",
                                            width: 100,
                                            type: "num_decimal",                                          
                                        },
                                        {   header: "Saldo",
                                            field: "saldo",
                                            width: 80,
                                            type: "num_decimal",                                            
                                        },
                                        {   header: "Retención",
                                            field: "retencion",
                                            width: 80,
                                            type: "num_decimal",                                              
                                        },
                                        {   header: "Val. aplicar",
                                            field: "val_aplicar",
                                            width: 80,
                                            type: "num_decimal_edit",
                                            editable: true                                               
                                        },
                                        {   header: "Vendedor",
                                            field: "Vendedor",
                                            width: 70,
                                            type: "string",                                              
                                        }
                                    ],
            columnDefs_DISPG:      [  
                                        {   header: "N° FP",
                                            field: "sec_VR",
                                            width: 45,
                                            type: "num_entero"                                                 
                                        },
                                        {   header: "Forma de pg.",
                                            field: "forma_pago",
                                            width: 139,
                                            type: "string"                                                 
                                        },
                                        {   header: "Doc.",
                                            field: "documento",
                                            width: 40,
                                            type: "string"                                                                                                           
                                        },                                        
                                        {   header: "Tipo",
                                            field: "tipo_doc",
                                            width: 40,
                                            type: "string"                                                
                                        },
                                        {   header: "Nro. Doc.",
                                            field: "num_doc",
                                            width: 95,
                                            type: "string"                                          
                                        },
                                        {   header: "Valor",
                                            field: "valor",
                                            width: 50,
                                            type: "num_decimal"                                            
                                        },
                                        {   header: "Mov.",
                                            field: "movimiento",
                                            width: 70,
                                            type: "string"                                               
                                        }
                                    ],
            columnDefs_LibroDiario:[    
                                        {   header: "Diario contable",
                                            field: "movimiento",
                                            width: 100,
                                            type: "num_entero"                                                 
                                        },
                                        {   header: "Tipo Mov.",
                                            field: "tipo_comprobante",
                                            width: 110,
                                            type: "string"                                                 
                                        },
                                        {   header: "Movimiento",
                                            field: "diario",
                                            width: 110,
                                            type: "num_entero"                                                                                                           
                                        }
                                    ],
            columnDefs_notas_credito:[  
                                        {   header: "Nota de credito",
                                            field: "nota_credito",
                                            width: 100,
                                            type: "num_entero"                                                 
                                        },
                                        {   header: "Factura",
                                            field: "nro_factura",
                                            width: 110,
                                            type: "string"                                                 
                                        },
                                        {   header: "Valor",
                                            field: "valor",
                                            width: 100,
                                            type: "num_decimal"                                                                                                           
                                        }
                                    ],

        };

        //GRID Valores recibidos
        this.gridOptionsRecibido = {
            context: {
                componentParent: this
            }, 
            rowSelection: 'single',   
            singleClickEdit: true,
            enableColResize: true,
            enableCellChangeFlash: true,
            onRowDoubleClicked: (event)=>{
                
                if(event.data.hasOwnProperty("fac_ret")===true){
                    var cadena = "";
                    let baseRet = event.data.TotalConIva+event.data.TotalSinIva;
 
                    cadena = cadena+"- Embalaje: "+Math.round(parseFloat(event.data.Embalaje,10)*100)/100;
                    cadena = cadena+"\n- Total con iva: "+Math.round(parseFloat(event.data.TotalConIva,10)*100)/100;
                    cadena = cadena+"\n- Total sin iva: "+Math.round(parseFloat(event.data.TotalSinIva,10)*100)/100;
                    cadena = cadena+"\n- BASE RET 1.75%: "+Math.round(parseFloat(baseRet,10)*100)/100;
                    cadena = cadena+"\n- BASE RET 2%: "+Math.round(parseFloat(event.data.Embalaje,10)*100)/100;
                    alert(cadena);
                }
            },
            onCellValueChanged: (event)=>{ 
                
                switch (event.colDef.field) {
                    case "fac_ret":
                        
                        var facturaparts;
                        facturaparts = (event.newValue).split("-");

                        if((event.data.fac_ret === "" || event.data.fac_ret === undefined ) /*&& event.oldValue === undefined */){
                            delete event.data.fac_ret;
                            event.data.FacturaTraida = 0; 
                            
                            //Recalculo de Valor a favor Cuando ingresan en blanco
                            let diferencia = this.calcularSaldoFavorCliente();
                            
                            this.setState({diferenciaVA: diferencia}, ()=>{
                            this.api.refreshCells();
                            })
                        }

                        if(parseInt(event.data.Forma_Pago, 10) !== 7 && String(event.data.fac_ret).length > 0 && event.data.hasOwnProperty('fac_ret')){
                            delete event.data.fac_ret;
                            this.api.refreshCells();
                            alert("Solo ingrese facturas a retenciones y efectivo deposito");
                        }
                        
                        if(event.data.hasOwnProperty('fac_ret') && event.data.fac_ret !== "" && parseInt(event.data.Forma_Pago, 10) === 7){
                            
                            Promise.all([
                                this.getValidacionFactura(facturaparts[0], facturaparts[1], this.props.cliente.value, this.state.recibo),
                                this.getFactura(facturaparts[0], facturaparts[1])
                            ])
                            .then(([result_factura, datos_factura])=>{
                                this.props.cambiar_VisualizacionLoading(true);
                                let diferenciaVA = 0;
                                switch (parseInt(result_factura, 10)) {
                                    case 1:
                                        this.props.cambiar_VisualizacionLoading(false);

                                        //Columna que indicador que factura fue traida y no esta en el recibo === 1
                                        event.data.FacturaTraida = 0; 

                                        this.setState({boton_distribuir: true})
                                        alert("La factura # "+event.newValue+" no existe o esta anulada"); 
                                        break;

                                    case 2:
                                        this.props.cambiar_VisualizacionLoading(false);

                                        //Columna que indicador que factura fue traida y no esta en el recibo === 1
                                        event.data.FacturaTraida = 0;

                                        alert("La factura # "+event.newValue+" no corresponde al cliente del recibo");                 
                                        this.setState({boton_distribuir: true})
                                        break;

                                    case 3:
                                        this.props.cambiar_VisualizacionLoading(false);
                                        alert("La factura # "+event.newValue+" no esta dentro de valores aplicados");
                                        this.setState({boton_distribuir: false})
                                        var factura = {};
                                        var No_valido;

                                        factura = datos_factura;
                                        factura.Tipo_Transaccion = 'FAC'
                                        
                                        No_valido = this.validarDocumentosPendientesrepetidos(this.state.doc_pendientes, event.newValue );
                                        console.log('VALID TRAIDA: ', No_valido)
                                        if(No_valido === false){

                                            //Actualiza las nuevas columnas para trabajar
                                            event.data.Embalaje = datos_factura.embalaje;
                                            event.data.TotalConIva = datos_factura.TotalConIva!==null?datos_factura.TotalConIva:0;
                                            event.data.TotalSinIva = datos_factura.TotalSinIva!==null?datos_factura.TotalSinIva:0;
                                            event.data.Iva = datos_factura.Iva!==null?datos_factura.Iva:0;
                                            //Calculo
                                            event.data.retFteBienes = Math.round((((datos_factura.TotalConIva+datos_factura.TotalSinIva)-datos_factura.embalaje)*0.0175)*100)/100;
                                            event.data.retFteServicio = Math.round((datos_factura.embalaje*0.02)*100)/100
                                            event.data.retIvaBienes = 0;
                                            event.data.retIvaServicio = 0;

                                            //Columna que indica que la FACTURA NO SE ENCUENTRA EN VA
                                            event.data.FacturaTraida = 1;

                                            let totalFactFueraVA = this.totalFactFueraValoresAplicados(this.state.grid_valores_recibidos)

                                            //Agrega factura a Catalogo de docPendientes
                                            var arraytemp = this.state.doc_pendientes;
                                            arraytemp.push(factura)

                                            //Recalculo de Valor a favor
                                            diferenciaVA = this.calcularSaldoFavorCliente();
                                            
                                            let totalAFavor = Math.round((diferenciaVA - totalFactFueraVA)*100)/100;
                                            this.setState({boton_distribuir: false, diferenciaVA: totalAFavor})

                                            this.setState({doc_pendientes: arraytemp, boton_distribuir: false,
                                                total_retencion_fact_traidas: totalFactFueraVA
                                            });
                                            this.api.refreshCells();

                                        }
                                        
                                        break;
                                    case 4:
                                        this.props.cambiar_VisualizacionLoading(false);
                                        alert("La factura # "+event.newValue+" ya tiene asignada una retención")
                                        
                                        //Columna que indicador que factura fue traida y no esta en el recibo === 1
                                        event.data.FacturaTraida = 0; 
                                                                            
                                        this.setState({boton_distribuir: true})
                                        break;
                                    default:
                                        //CASO POR DEFECTO INGRESA FACTURAS EXISTENTES DE VA
                                        //let validate = 0;
                                        //validate = Math.round((datos_factura.TotalConIva*0.01)*100)/100;

                                       //if(Math.round(event.data.ValorRecaudado*100)/100===Math.round(validate*100)/100){
                                        event.data.Embalaje = datos_factura.embalaje;
                                        event.data.TotalConIva = datos_factura.TotalConIva;
                                        event.data.TotalSinIva = datos_factura.TotalSinIva;
                                        event.data.Iva = datos_factura.Iva;

                                        //Calculo
                                        
                                        event.data.retFteBienes = Math.round((((datos_factura.TotalConIva+datos_factura.TotalSinIva)-datos_factura.embalaje)*0.0175)*100)/100;
                                        event.data.retFteServicio = Math.round((datos_factura.embalaje*0.02)*100)/100
                                        // event.data.retFteBienes = ((datos_factura.TotalConIva+datos_factura.TotalSinIva)-datos_factura.embalaje)*0.01
                                        // event.data.retFteServicio = datos_factura.embalaje*0.02
                                        event.data.retIvaBienes = 0;
                                        event.data.retIvaServicio = 0;

                                        //Recalculo de Valor a favor
                                        diferenciaVA = this.calcularSaldoFavorCliente();                                     
                                        this.setState({boton_distribuir: false, diferenciaVA: diferenciaVA})
                                        this.api.refreshCells();
                                        // }else{
                                        //     this.props.cambiar_VisualizacionLoading(false);
                                        //     delete event.data.fac_ret;
                                        //     this.api.refreshCells();
                                        //     alert("La factura ingresada no corresponde a la retención")
                                        //     this.setState({boton_distribuir: true})
                                        // }

                                        //Columna que indicador que factura fue traida y no esta en el recibo === 1
                                        event.data.FacturaTraida = 0;

                                        this.props.cambiar_VisualizacionLoading(false);
                                    break;
                                    
                                }
                            })                                                        
                            .catch((error)=>{
                                this.props.cambiar_VisualizacionLoading(false);
                                console.log("ERROR INGRESO FACTURA: ", error)
                            })
                        }
                        
                        break;

                    case "Cheque":
                        /* Permite editar CHQS y Formas de pago efectivas */
                        if(parseInt(event.data.Forma_Pago, 10) === 1 || parseInt(event.data.Forma_Pago, 10) === 2 || parseInt(event.data.Forma_Pago, 10) === 6 || parseInt(event.data.Forma_Pago,10)===3 || parseInt(event.data.Forma_Pago,10)===8 || parseInt(event.data.Forma_Pago,10)===4 || parseInt(event.data.Forma_Pago,10)===5){                                                        
                            event.data.Cheque = event.newValue;
                            this.api.refreshCells();

                            //Validacion para no crear auditoria con valores repetidos del grid                            
                            if(event.newValue !== event.oldValue){
                                
                                //Adicion para añadir cambios de cheque a la auditoria
                                console.log('Fila enviada: ', event.data)
                                this.insertUpdateArrayCambiosAuth(event.data, 'ChequeCambio', 'ChequeOriginal',event.oldValue, 'Cheque')
                            }                            
                        }else{
                            if(String(event.data.Cheque).length > 0 && event.data.hasOwnProperty('Cheque')){
                                alert("Cambio valido solo para cheques y efectivos");
                                event.data.Cheque = event.oldValue;
                                this.api.refreshCells();
                            }
                        }                                                    
                        break;

                    case "Cuenta":
                        console.log('IM HERE: ', event.data.Forma_Pago)
                        if(parseInt(event.data.Forma_Pago, 10) === 1 || parseInt(event.data.Forma_Pago, 10) === 2 || parseInt(event.data.Forma_Pago, 10) === 6 || parseInt(event.data.Forma_Pago, 10) === 5 || parseInt(event.data.Forma_Pago, 10) === 4){                                                        
                            console.log('EVENT DATA BANCO: ', event.data.Banco_num)
                            if(event.data.Banco_num && event.data.Cuenta){
                                this.validacionBancoCuentaPorCliente(this.state.cliente_sel.value, event.data.Banco_num, event.newValue)
                                .then((validCuenta)=>{

                                    if(validCuenta.status === 204){
                                        alert('Combinación banco, cuenta y cliente no se encuentra registrada. Revise la matriculación de cuentas del cliente\n');
                                        event.data.Cuenta = event.oldValue;
                                        this.api.refreshCells();   
                                    }else if(validCuenta.status === 200){

                                        console.log('validCuenta: ', validCuenta);
                                        event.data.Cuenta = event.newValue;
                                        this.api.refreshCells();

                                        //Validacion para no crear auditoria con valores repetidos del grid                            
                                        if(event.newValue !== event.oldValue){
                                            //Adicion para añadir cambios de cheque a la auditoria
                                            this.insertUpdateArrayCambiosAuth(event.data, 'CuentaCambio', 'CuentaOriginal',event.oldValue, 'Cuenta')
                                        }
                                    }
                                })
                                .catch((error)=>{
                                    alert(error.response?error.response.data.msg:error.message);
                                })
                            }else{
                                alert('Datos faltantes para la validación de cuenta, revise banco o num. cheque');
                                event.data.Cuenta = event.oldValue;
                                this.api.refreshCells();                               
                            }                            
                        }else{
                            if(String(event.data.Cuenta).length > 0 && event.data.hasOwnProperty('Cuenta')){
                                alert("Cambio válido solo para cheques");
                                event.data.Cuenta = event.oldValue;
                                this.api.refreshCells();
                            }
                        }
                        break;

                    case "Vencimiento_cheq":
                        if(parseInt(event.data.Forma_Pago, 10) === 1 || parseInt(event.data.Forma_Pago, 10) === 2 || parseInt(event.data.Forma_Pago, 10) === 6){                                                        
                            event.data.Vencimiento_cheq = event.newValue;
                            //Validador de fecha invalida
                            var resultado;
                            resultado = validarFechaMomentEnFormatoString(event.newValue);

                            if(resultado===true && parseInt(event.data.Forma_Pago,10)!==3 && parseInt(event.data.Forma_Pago,10)!==8){
                                console.log('NO DEBES ENTRAR AQUI POR EFECTIVO')
                                this.validacionCheques();

                                    //Validacion para no crear auditoria con valores repetidos del grid
                                    if(event.newValue !== event.oldValue){

                                        //Adicion para añadir cambios de cheque a la auditoria
                                        this.insertUpdateArrayCambiosAuth(event.data, 'FechaVenCambio', 'FechaVenOriginal',event.oldValue, 'Vencimiento_cheq')  
                                    }                                    
                            }else if(resultado===false){
                                event.data.Vencimiento_cheq = event.oldValue;
                            }
                       
                            this.api.refreshCells();
                        }else{
                            if(String(event.data.Vencimiento_cheq).length > 0 && event.data.hasOwnProperty('Vencimiento_cheq')){
                                alert("Cambio valido solo para cheques");
                                event.data.Vencimiento_cheq = event.oldValue;
                                this.api.refreshCells();
                            }
                        }
                        break;

                    case "FechaDeposito":
                        if(parseInt(event.data.Forma_Pago,10)===3 || parseInt(event.data.Forma_Pago,10)===8 || parseInt(event.data.Forma_Pago,10)===4 || parseInt(event.data.Forma_Pago,10)===5){
                            let resultado = validarFechaMomentEnFormatoString(event.newValue);

                            if(resultado === false){
                                event.data.FechaDeposito = event.oldValue;
                            }
                        }else{
                            event.data.FechaDeposito = event.oldValue;
                        }
                        break;
                    
                    case "ValorRecaudado":
                        if(parseInt(event.data.Forma_Pago, 10) === 1 || parseInt(event.data.Forma_Pago, 10) === 2 || parseInt(event.data.Forma_Pago, 10) === 6){                                                        
                            let paramChMas = 0, paramChMenos = 0;
                            let valor;

                            valor = parseFloat(event.newValue,10);
                            if(isNaN(valor)===false){
                                this.state.parametros_che.forEach((PARAM)=>{
                                    if(PARAM.label === 'CHE-'){
                                        paramChMenos = parseFloat(PARAM.value, 10)
                                    }else if(PARAM.label === 'CHE+'){
                                        paramChMas = parseFloat(PARAM.value, 10)
                                    }
                                })
                                
                                let valueMax = parseFloat(event.oldValue, 10) + paramChMas;
                                let valueMin = parseFloat(event.oldValue, 10) + paramChMenos;
                                event.data.ValorRecaudado = parseFloat(event.newValue, 10);
                                
                                if(event.data.ValorRecaudado < valueMin || event.data.ValorRecaudado > valueMax){
                                    event.data.ValorRecaudado = event.oldValue;  
                                }
    
                                let valor_aplicado = 0, retencion = 0, total = 0, totalAplicado = 0 , diferencia = 0;
                                totalAplicado = this.SumValoresGrid(this.state.grid_valores_aplicados, 'valor');  
                                

                                this.state.grid_valores_recibidos.forEach((VR, i)=>{
                                    console.log('VUELTA: ', i)

                                    if(parseInt(VR.Forma_Pago,10)===7){
                                        
                                        retencion += parseFloat(VR.ValorRecaudado);
                                        console.log(VR.secuencia, 'RET SUM: ', retencion, 'FP: ', VR.Forma_Pago)
                                    }
                                    if(parseInt(VR.Forma_Pago,10)!==7){
                                        
                                        valor_aplicado += parseFloat(VR.ValorRecaudado)
                                        console.log(VR.secuencia, 'VAL SUM: ', valor_aplicado, 'FP: ', VR.Forma_Pago)
                                    }
                                })

                                total = valor_aplicado + retencion;
                                diferencia = total - totalAplicado
                                console.log('GRID: ', this.state.grid_valores_recibidos)
                                console.log('VAL aplicado: ', valor_aplicado, 'RET: ', retencion, 'Total: ', total)                          

                                this.setState({c_total_recibo: formatearNumeroDecimal( (Math.round(total*100)/100).toFixed(2)) , 
                                    total_recibidos: Math.round(valor_aplicado*100)/100, 
                                    total_retencion: Math.round(retencion*100)/100,
                                    diferenciaVA: Math.round(diferencia*100)/100
                                });
                          
                            }else{
                                event.data.ValorRecaudado = parseFloat(event.oldValue, 10);
                            }                                                        
                        }else if(parseInt(event.data.Forma_Pago, 10) === 7){
                            let paramRETMas = 0 
                            let paramRETMenos = 0;
                            let valor;

                            valor = parseFloat(event.newValue,10);
                            if(isNaN(valor)===false){
                                this.state.parametros_ret.forEach((PARAM)=>{
                                    if(PARAM.label === 'RET+'){
                                        paramRETMas = parseFloat(PARAM.value, 10)
                                    }else 
                                    if(PARAM.label === 'RET-'){
                                        paramRETMenos = parseFloat(PARAM.value, 10)
                                    }
                                })

                                let valueMax = Math.round((parseFloat(event.oldValue, 10) + paramRETMas)*100)/100;
                                let valueMin = Math.round((parseFloat(event.oldValue, 10) + paramRETMenos)*100)/100;
                                event.data.ValorRecaudado = parseFloat(event.newValue, 10);
                                //console.log('VALOR MIN: ', valueMin, 'VALOR MAX: ', valueMax, 'VALOR INPUT: ', event.data.ValorRecaudado)
                                if(event.data.ValorRecaudado < valueMin || event.data.ValorRecaudado > valueMax){
                                    event.data.ValorRecaudado = event.oldValue;  
                                }

                                let valor_aplicado = 0, retencion = 0, total = 0, totalAplicado = 0 , diferencia = 0;
                                totalAplicado = this.SumValoresGrid(this.state.grid_valores_aplicados, 'valor');  
                                

                                this.state.grid_valores_recibidos.forEach((VR, i)=>{
                                    if(parseInt(VR.Forma_Pago,10)===7){
                                        retencion += parseFloat(VR.ValorRecaudado);
                                    }
                                    if(parseInt(VR.Forma_Pago,10)!==7){
                                        valor_aplicado += parseFloat(VR.ValorRecaudado)
                                    }
                                })

                                total = valor_aplicado + retencion;
                                diferencia = total - totalAplicado;                      

                                this.setState({c_total_recibo: Math.round(total*100)/100, 
                                    total_recibidos: Math.round(valor_aplicado*100)/100, 
                                    total_retencion: Math.round(retencion*100)/100,
                                    diferenciaVA: Math.round(diferencia*100)/100
                                });
                            }else{
                                event.data.ValorRecaudado = parseFloat(event.oldValue, 10);
                            }  
                        }else{
                            if(String(event.data.ValorRecaudado).length > 0 && event.data.hasOwnProperty('ValorRecaudado')){
                                alert("Cambio valido solo para cheques y retenciones");
                                event.data.ValorRecaudado = parseFloat(event.oldValue, 10);                                
                            }
                        }
                        break;

                    case 'retIvaBienes':
                        let impuestoB = this.state.retIvaCliSel
                        console.log('Servicio: ', impuestoB)
                        if(Object.keys(impuestoB).length>1){
                            if(impuestoB.hasOwnProperty('bienes')===true && event.data.retIvaBienes!==''){
                                let imp =  parseInt(impuestoB.bienes,10)/100;
                                let valor = parseFloat(event.data.ValorRecaudado,10);
                                let retBienes = parseFloat(event.newValue,10);
                                let retCal = Math.round((valor*imp)*100)/100
                                console.log("RET CAL: ", retCal, 'Imp: ', imp, 'ValorRecaudado: ',valor )
                                event.data.retIvaBienes = retBienes;
                                // if(retBienes > retCal){
                                //     alert(`- El valor ingresado supera al valor maximo permitido para Ret.Iva del ${impuestoB.bienes}`)
                                //     event.data.retIvaBienes = 0;
                                // }
                            }else{
                                event.data.retIvaBienes = 0; 
                            }
                        }else{
                            event.data.retIvaBienes = 0;
                        }                    
                        break;

                    case 'retIvaServicio':
                        let impuestoS = this.state.retIvaCliSel
                        console.log('Servicio: ', impuestoS)
                        
                        if(Object.keys(impuestoS).length>1){
                            if(impuestoS.hasOwnProperty('servicio')===true && event.data.retIvaServicio!==''){
                                let imp =  parseInt(impuestoS.servicio,10)/100;
                                let valor = parseFloat(event.data.ValorRecaudado,10);
                                let retServicio = parseFloat(event.newValue,10);
                                let retCal = Math.round((valor*imp)*100)/100
                                console.log("RET CAL: ", retCal, 'Imp: ', imp, 'ValorRecaudado: ',valor )
                                event.data.retIvaServicio = retServicio
                                // if(retServicio > retCal){
                                //     alert(`- El valor ingresado supera al valor maximo permitido para Ret.Iva del ${impuestoS.servicio}`)
                                //     event.data.retIvaServicio = 0;
                                // }
                            }else{
                                event.data.retIvaServicio = 0; 
                            }
                        }else{
                            event.data.retIvaServicio = 0;
                        }
                        break;

                    case 'RtfBienes':
                        event.data.RtfBienes = parseFloat(event.newValue)
                    break;

                    case 'RtfServicio':
                        event.data.RtfServicio = parseFloat(event.newValue)
                    break;

                    default:
                    break;
                }

                this.eliminarDocumentosPendientesTraidos();

                //Recalculo de Valor a favor
                let diferenciaVA = this.calcularSaldoFavorCliente();
                let totalFactFueraVA = this.totalFactFueraValoresAplicados(this.state.grid_valores_recibidos) 

                let totalAFavor = Math.round((diferenciaVA - totalFactFueraVA)*100)/100;

                this.setState({total_retencion_fact_traidas: totalFactFueraVA, diferenciaVA: totalAFavor}, ()=>{
                    this.api.refreshCells(); 
                })      
            },
            onCellEditingStarted: ((event)=>{
                let impuesto = this.state.retIvaCliSel
                if( ((event.colDef.field==='retIvaBienes' || event.colDef.field==='retIvaServicio' ) && impuesto===null && parseInt(event.data.Forma_Pago, 10) === 7) ){
                    alert('- El cliente no tiene parametros para Ret.Iva.');
                    this.api.stopEditing();
                }
                if(event.colDef.field==='FechaDeposito' && parseInt(event.data.Forma_Pago, 10) !== 3 && parseInt(event.data.Forma_Pago, 10) !== 8 && parseInt(event.data.Forma_Pago, 10) !== 4 && parseInt(event.data.Forma_Pago, 10) !== 5){
                    alert('- La fecha deposito solamente se ingresa para efectivo, efectivo/depósito , depósito y transferencia.');
                    this.api.stopEditing();
                }
            })
        };
        
        //Valores Aplicados
        this.gridOptionsAplicado = {
            context: {
                componentParent: this
            },      
            enableColResize: true
        };

        //Documentos pendientes
        this.gridOptionsPendientes = {
            context: {
                componentParent: this
            },
            enableColResize: true,
            enableCellChangeFlash: true,
            onCellValueChanged: (event)=>{
                
                
                switch(event.colDef.field){
                    case "val_aplicar":
                        
                        /*if(event.data.hasOwnProperty('marcador')){
                            event.data.val_aplicar = event.newValue;

                            if((event.data.val_aplicar === "" || event.data.val_aplicar === undefined || parseFloat(event.data.val_aplicar) > parseFloat(event.data.saldo) )){
                                //delete event.data.val_aplicar;
                                event.data.val_aplicar = 0;                                
                            }
                            let valor_aplicado= 0;
                            valor_aplicado = this.SumValoresGrid(this.state.grid_docs_pendientes, 'val_aplicar');                            
                            
                            console.log("DP VALOR AP: ", valor_aplicado)
                            this.setState({total_aplicado_DP: valor_aplicado});                            
                        }else{
                            event.data.val_aplicar = event.oldValue;
                            alert("Cambio no permitido...");
                        }
                        */

                        if(!event.data.val_aplicar){
                            event.data.val_aplicar = 0;     
                        }
                        let valAplicar = Math.round((parseFloat(event.data.val_aplicar))*100)/100;
                        let valSaldo = Math.round((parseFloat(event.data.saldo))*100)/100;
                        if(valAplicar > valSaldo){
                            event.data.val_aplicar = event.oldValue;
                            alert("Cambio no permitido, el valor es mayor al saldo.");
                        }else{
                            let valor_aplicado= 0;
                            valor_aplicado = this.SumValoresGrid(this.state.grid_docs_pendientes, 'val_aplicar');                            
                            
                            console.log("DP VALOR AP: ", valor_aplicado)
                            event.data.val_aplicar = parseFloat(event.newValue,10)
                            this.setState({total_aplicado_DP: valor_aplicado}); 
                        } 
                        
                        break;
                    default:
                    break
                }
                this.apiDP.refreshCells();
            },
            getRowStyle: (params) =>{
                if (params.data.hasOwnProperty('Login')===true) {
                  return {'background-color': '#FAFAD2'}
                }
                return null;
            }
        };

        //Distribucion de Pago
        this.gridOptionsPago = {
            context: {
                componentParent: this
            },      
            enableColResize: true
        };

        this.onGridReady = this.onGridReady.bind(this);
        this.onGridReadyDP = this.onGridReadyDP.bind(this);
        this.changeRecibo = this.changeRecibo.bind(this);
        this.getCobranza = this.getCobranza.bind(this);
        this.AplicarRecaudador = this.AplicarRecaudador.bind(this);
        this.Limpiar = this.Limpiar.bind(this);
        this.limpiarPantalla = this.limpiarPantalla.bind(this);
        this.distribuirDocsPendientesRET = this.distribuirDocsPendientesRET.bind(this);
        this.getDocumentosPorPeticion = this.getDocumentosPorPeticion.bind(this);
        this.getDocumentosDistribuidos = this.getDocumentosDistribuidos.bind(this);
        this.modificarValoresRecibidos = this.modificarValoresRecibidos.bind(this);
        this.logIn = this.logIn.bind(this);
        this.changeUser = this.changeUser.bind(this);
        this.changePass = this.changePass.bind(this);
        this.impCarteraCliente = this.impCarteraCliente.bind(this);
        this.getId_Doc = this.getId_Doc.bind(this);
        this.cambiarBancosPorFila = this.cambiarBancosPorFila.bind(this);
        this.calcularSaldoFavorCliente = this.calcularSaldoFavorCliente.bind(this);
        this.actualizarCampos = this.actualizarCampos.bind(this);

        this.deleteporItemInexistente = this.deleteporItemInexistente.bind(this);

        this.validacionSobrepagoDentroDP = this.validacionSobrepagoDentroDP.bind(this);
    }

    //Validacion CTA!
    validacionBancoCuentaPorCliente(cliente, banco, cuenta){
        return new Promise((resolve, reject)=>{
            global_axios.get(`clientes/${cliente}/banco/${banco}/cuenta/${cuenta}`)
            .then((response)=>{
                resolve(response);
            })
            .catch((err)=>{
                reject(err);
            });
        });
    }

    //Totaliza Facturas que no estan en VA
    totalFactFueraValoresAplicados(VR){
        let acc = 0;
        if(VR.length > 0){
            VR.forEach((VR)=>{
                if(VR.hasOwnProperty('FacturaTraida') === true){
                    if(VR.FacturaTraida === 1){
                        acc+=parseFloat(VR.ValorRecaudado)
                    }
                }
            })
        }
        return Math.round(acc*100)/100;
    }

    actualizarCampos(event){
        const target = event.target;       
        const name = target.name;    
        const value = target.type === 'checkbox'? target.checked : target.value;
        this.setState({[name]: value});
    }

    //Get
    //Opcion a consultar , Nombre del state a guardar
    cargarCatalogosOtrosCatchResult(tipo, name) {
        return new Promise((resolve, reject) => {
            global_axios.get('/catalogos?tipo=otros&opcion=' + tipo)
            .then((response)=>{
                this.setState({[name]: response.data});

                resolve(response.data.map(item => ({value: item.Codigo.toString().toUpperCase(), label: `${item.Descripcion.toString().toUpperCase()} (${item.Codigo.toString().toUpperCase()})` })));
            })
            .catch((err)=>{
                reject('Error al cargar datos de catálogos desde API: ' + err);
            });
        });
    }

    cargarCatalogosOtrosSaveCat(tipo, name){
        return new Promise((resolve, reject) => {
            global_axios.get('/catalogos?tipo=otros&opcion=' + tipo)
            .then((response)=>{
                this.setState({[name]: response.data});
                resolve(response.data);
            })
            .catch((err)=>{
                reject('Error al cargar datos de catálogos desde API: ' + err);
            });
        });
    }

    getOptions_Clientes(input, callback){        
        if (input.toString().length >= 2 ){
            let query = "?cadena_busq=" + input;     
            cargarCatalogosGenericoAsync('/clientes', query, callback)
          }
    }

    //================ MODALS=============================
    toggleModal = () => {
        this.setState({
            isOpenSuper: !this.state.isOpenSuper
        });
    }
    //====================================================

    clear_ActionButtons(){
        //Clear botones
        this.setState({ recaudador: true, cartera: true, cobro: true })//Guardar
    }

    distribuirRecibido(){

        //Control de errores
        var arr_Error_valor_retenciones = "";
        //var arr_Error_valor_desglosado_ret = "";
        var arr_Error_asig_facturas = "";
        var proceder = true;

        //Encerar grids caso retención
        if(this.state.grid_docs_pendientes.length > 0 && this.state.grid_distribucionpago.length > 0){
            this.setState({grid_docs_pendientes: [], grid_distribucionpago: []});            
        }

        for(var index = 0; index < this.state.grid_valores_recibidos.length; index++ ){

            //Validacion sobre formas de pago ajenas a ret
            if(parseInt(this.state.grid_valores_recibidos[index].Forma_Pago, 10) !== 7){
                if(this.state.grid_valores_recibidos[index].hasOwnProperty('fac_ret')){
                    alert("Asigne facturas solo a retenciones");
                    break;
                }
            }
              
            //Eventos sobre retenciones
            if(parseInt(this.state.grid_valores_recibidos[index].Forma_Pago, 10) === 7){

                //Validacion: se haya ingresado una factura en la columna fac_ret
                if(!this.state.grid_valores_recibidos[index].hasOwnProperty('fac_ret')){
                    arr_Error_asig_facturas = arr_Error_asig_facturas.concat(String(this.state.grid_valores_recibidos[index].Cheque+", "));  
                }else{
                    let retRtfBienes, retRtfServicio, retIvaBienes, retIvaServicio, totalImp
                    retRtfBienes = this.state.grid_valores_recibidos[index].retFteBienes !==""? this.state.grid_valores_recibidos[index].retFteBienes:0;
                    retRtfServicio = this.state.grid_valores_recibidos[index].retFteServicio !==""?this.state.grid_valores_recibidos[index].retFteServicio:0;
                    retIvaBienes = this.state.grid_valores_recibidos[index].retIvaBienes !==""?this.state.grid_valores_recibidos[index].retIvaBienes:0;
                    retIvaServicio = this.state.grid_valores_recibidos[index].retIvaServicio !==""?this.state.grid_valores_recibidos[index].retIvaServicio:0;
                    totalImp = this.state.grid_valores_recibidos[index].ValorRecaudado !==""?this.state.grid_valores_recibidos[index].ValorRecaudado:0;   

                    if(this.validacionImpuestoRetVR(retRtfBienes!==null?retRtfBienes:0, retRtfServicio!==null?retRtfServicio:0,
                        retIvaBienes!==null?retIvaBienes:0, retIvaServicio!==null?retIvaServicio:0, totalImp!==null?totalImp:0)===false){
                        arr_Error_valor_retenciones = arr_Error_valor_retenciones.concat(String(this.state.grid_valores_recibidos[index].Cheque+", "));
                    }
                }
            }
        }

        //Validacion Facturas repetidas
        var arr_Error_fac_repetidas = ""
        var error = []

        error = this.validarFacturasrepetidas(this.state.grid_valores_recibidos);

        if(arr_Error_asig_facturas !==""){
            alert("Asigne facturas a las retenciones: "+arr_Error_asig_facturas);
            proceder = false;
        }

        if(arr_Error_valor_retenciones!==""){
            alert("Monto superior al valor recaudado en el documentos: "+arr_Error_valor_retenciones);
            proceder = false;
        }

        arr_Error_fac_repetidas = this.asignarFactrepetidas(error)
        if(arr_Error_fac_repetidas !== ""){
            alert("La factura de la retencion estan repetidas: "+arr_Error_fac_repetidas);
            proceder = false;
        }

        if(this.state.cheq_alert === true){
            alert("Existen cheques con una fecha de vencimiento menor a la fecha del recibo: "+this.state.recibo);
        }

        if(proceder === true && this.state.cheq_alert === false){
            var numero_ret = this.props.num_ret;        
            var result = [];

            //Asignacion de facturas de valores aplicados
            this.setState({total_saldo_recibido: this.props.Total_saldo_p }); 
            this.setState({total_ret_recibido: this.state.total_retencion})

            //Asignacion de valores
            result = this.CreacionGridDocumentosPendientes(this.state.grid_valores_aplicados, this.state.grid_valores_recibidos , numero_ret)
            
            /* Trae documentos pendientes cargados */
            let docsTraidos = this.state.docs_porPeticion;
            
            let arrayFinal = [];
            if(docsTraidos.length > 0){
                arrayFinal = result.concat(docsTraidos)
            }else{
                arrayFinal = result
            }
            console.log('ARRAY A AÑADIR DP:', arrayFinal)
            this.setState({ grid_docs_pendientes: arrayFinal },()=>{
                
                //Bloquea campos editables
                this.lockGridVR();
            });

            //Activacion boton aplicar_distribuido
            this.setState({boton_aplicar_distribucion: false});
        }
    }

    //CALCULO DE SALDO A FAVOR De CLIENTE
    calcularSaldoFavorCliente(){
        let totalRecibidos = parseFloat(this.state.total_recibidos);
        let totalRetencion = parseFloat(this.state.total_retencion);
        let totalAplicado = parseFloat(this.state.total_aplicacion);

        let total = Math.round((totalRecibidos + totalRetencion)*100)/100;
        let diferencia = Math.round((total - totalAplicado)*100)/100

        return diferencia;
    }

    //POR TRUE VALORES SIN PROBLEMAS POR FALSO VALORES NO CUADRAN
    validacionImpuestoRetVR(retRtfBienes, retRtfServicio, retIvaBienes, retIvaServicio, totalImp){

        var result = true;
        var subtotal = Math.round((parseFloat(retRtfBienes,10) + parseFloat(retRtfServicio,10) + parseFloat(retIvaBienes,10) + parseFloat(retIvaServicio,10))*100)/100; 
        
        //Added 28/01/19
        //let paramRETMas = 0, 
        let paramRETMenos = 0;

        this.state.parametros_ret.forEach((PARAM)=>{
            // if(PARAM.label === 'RET+'){
            //     paramRETMas = parseFloat(PARAM.value, 10)
            // }else 
            if(PARAM.label === 'RET-'){
                paramRETMenos = parseFloat(PARAM.value, 10)
            }
        })

        //let maxValue = Math.round((totalImp + paramRETMas)*100)/100;
        let mimvalue = Math.round((totalImp + paramRETMenos)*100)/100;
        
        if(subtotal !== totalImp){            
            if(subtotal < mimvalue || subtotal > totalImp){
                result = false;
            }
        }
        return result
    }

    desactivarDistribuidos(){
        this.setState({boton_distribuir: true, boton_aplicar_distribucion: true});
    }

    CreacionGridDocumentosPendientes(VA, VR, numero_ret){
        //RETENCIONES CUYAS FACTURAS ESTAN EN APLICADAS
        //Verificacion de facturas aplicadas contra facturas recibidas
        var arrayResult = [];        
        var accRet = 0.00;
        var accSaldo = 0.00;

        var ERROR_log = [];
        
        for(var index = 0; index < VA.length ; index++){
            if(VA[index].saldo > 0){
                var movimiento = VA[index].Movimiento;
            }else{
                continue;
            }          
            var j = 0;
            while(j < VR.length){
                if(parseInt(VR[j].Forma_Pago, 10) === 7 ){
                    //console.log('VA MOV: ', movimiento, 'VR FAC RET: ', VR[j].fac_ret, 'COMPARATION: ',movimiento.toString().trim() === VR[j].fac_ret.toString().trim())    
                    if(movimiento.toString().trim() === VR[j].fac_ret.toString().trim()){
                        var itemEval = {}
                  
                        itemEval.Tipo_Transaccion = VA[index].Tipo_Transaccion;
                        itemEval.Movimiento = VA[index].Movimiento;
                        itemEval.fecha = VA[index].fecha;
                        
                        //itemEval.retencion = VR[j].ValorRecaudado; ADDED
                        itemEval.retencion = this.calcularSubTotalFilaVR(VR[j]);
                        //accRet = accRet + VR[j].ValorRecaudado;
                        accRet = accRet + this.calcularSubTotalFilaVR(VR[j]);
                        itemEval.valor = parseFloat(VA[index].valor);
                        itemEval.saldo = parseFloat(VA[index].saldo);
                        
                        accSaldo = accSaldo + VA[index].saldo;
                        
                        var temp = parseFloat(VA[index].valor);
                        var saldo_doc = VA[index].saldo;

                        if( Math.round((temp - parseFloat(VR[j].ValorRecaudado)) * 100)/100 < saldo_doc){
                            itemEval.val_aplicar = Math.round((temp - parseFloat(VR[j].ValorRecaudado)) * 100) / 100;
                            if(itemEval.val_aplicar < 0){
                                itemEval.val_aplicar = 0;
                            }
                        }else{
                            ERROR_log = ERROR_log.concat(String((VR[j].Cheque).trim()+", ")); 
                        }                        
                        
                        itemEval.Vendedor = VA[index].Vendedor;

                        //Asignacion de indicador
                        VR[j].Indicador = 1;
                        
                        VA[index].Indicador = 1;
                        arrayResult.push(itemEval);  
                        j++;                        
                    }
                }
                j++;
            }
        }
        console.log('VAR accRet AL TERMINAR PRIMER WHILE: ', accRet)
        console.log('ARRAY DP HASTA CASO NORMAL: ', arrayResult)
        
        //DOCUEMTOS EN APLICADOS QUE NO TIENEN RETENCIONES EN RECIBIDOS
        VA.forEach((det)=>{
            if(det.hasOwnProperty("Indicador")===false){
                console.log('ENTRO A INDICADOR ===  false')
                var item = {};
                item.Tipo_Transaccion = det.Tipo_Transaccion;
                item.Movimiento = det.Movimiento;
                item.fecha = det.fecha;
                item.valor = det.valor;
                item.saldo =  det.saldo;
                item.retencion = 0.00;
                item.val_aplicar = det.valor > det.saldo?det.saldo:det.valor;
                item.Vendedor = det.Vendedor;
                if(item.fecha){
                    arrayResult.push(item);
                }                
            }
        })

        console.log('ARRAY DP CON FILAS SIN COL INDICADOR === FALSE: ', arrayResult)

        //Retenciones cuyas facturas no se encuentra en valores aplicados
        //Cuando la factura no se encuentra en valores aplicados
        for(var i = 0 ; i < VR.length; i++){
        
            if(parseInt(VR[i].Indicador, 10) === 0){
                console.log('ENTRO A INDICADOR === 0')
                var item = {};
                var result_factura = {};
                
                result_factura = this.getValDocuments(this.state.doc_pendientes, VR[i].fac_ret)

                item.Tipo_Transaccion = result_factura.tipo;
                item.Movimiento = VR[i].fac_ret;
                item.fecha = result_factura.fecha;
                item.retencion = VR[i].ValorRecaudado;
                console.log("ACCRET EN FUNCION INDICADOR 0 ANTES ACC: ", accRet ,  VR[i].ValorRecaudado)
                //accRet = accRet + VR[i].ValorRecaudado;
                accRet = accRet + this.calcularSubTotalFilaVR(VR[i]);
                var valor = result_factura.valor_original;
                var saldo = result_factura.saldo;
                item.valor = valor;
                item.saldo = saldo;

                if(this.state.sobre_pago ===true){
                    item.val_aplicar = 0;    
                }else{
                    //item.val_aplicar = (VR[i].ValorRecaudado*-1);
                    item.val_aplicar = 0;

                }
                item.Vendedor = result_factura.vendedor;
                
                if(item.fecha){
                    arrayResult.push(item);
                }   
            }
        }

        console.log("ACCRET DESPUES PROCESO: ", accRet)
        
        var auxacc_ap = 0.00;
        auxacc_ap = this.SumValoresGrid(arrayResult, 'val_aplicar');        
        
        this.setLabelTotal_aplicados(Math.round(auxacc_ap * 100) / 100 , Math.round(accRet * 100) / 100, Math.round(accSaldo * 100) / 100);
        
        if(ERROR_log.length > 0){
            alert("Los documentos #: "+ERROR_log+"tienen un valor a aplicar mayor al saldo disponible");
            this.setState({Error_distribucion_recibida: true});
        }

        return arrayResult
    }

    calcularSubTotalFilaVR(fila){
        let totalFila = Math.round((parseFloat(fila.retFteBienes,10) + parseFloat(fila.retFteServicio,10) + parseFloat(fila.retIvaBienes,10) + parseFloat(fila.retIvaServicio,10))*100)/100; 
        return totalFila;
    }

    setLabelTotal_aplicados(valor_aplicado , valor_ret, valor_saldo){

        this.setState({total_aplicado_DP: valor_aplicado})
        this.setState({total_ret_DP: valor_ret})
        this.setState({total_saldo_recibido_DP: valor_saldo});
    }
       
    validarFacturasrepetidas(array){

        var control_rep;
        var j;
        var error = [];

        for(var i = 0; i < array.length; i++ ){
            if(parseInt(array[i].Forma_Pago, 10) !== 7){
                continue;
            }
            control_rep = array[i].fac_ret;
            j=i+1;

            while(j < array.length){
                if(array[j].fac_ret === control_rep && array[j].hasOwnProperty('fac_ret')){
                    if(error.indexOf(array[j].Cheque)=== -1){
                        error.push(array[j].Cheque)
                    }else{
                        if(error.length <=0){
                            error.push(array[j].Cheque)
                        }
                    }
                }  
                j++;
            }
        }

        return error;  
    }

    validarDocumentosPendientesrepetidos(array, control){
        var result = false;
        for(var i=0; i < array.length ; i++){
            if(array[i].Movimiento === control){
                result = true;
                break;
            }
        }
        return result;
    }

    //FUNCION PARA BORRAR DOCS PENDIENTES TRAIDOS QUE NO ESTAN ASIGNADOS EN VR
    eliminarDocumentosPendientesTraidos(){
        let movimiento = null;
        let arrayDelete = []
        
        for(var i = 0; i < this.state.doc_pendientes.length; i++){
            movimiento = this.state.doc_pendientes[i].Movimiento?this.state.doc_pendientes[i].Movimiento:null;

            let j = 0;
            let find = false;
            if(this.state.grid_valores_recibidos.length > 0 && movimiento !==null){
                while (j < this.state.grid_valores_recibidos.length){
                    if(parseInt(this.state.grid_valores_recibidos[j].Forma_Pago,10) === 7){
                        console.log('Comparacion ANTES DELETE')
                        console.log('Mov Param: ', movimiento , 'ARRAY Mov: ', this.state.grid_valores_recibidos[j].fac_ret, 'Comparacion: ',movimiento === this.state.grid_valores_recibidos[j].fac_ret)
                        if(movimiento === this.state.grid_valores_recibidos[j].fac_ret){
                            find = true;
                        }
                    }
                    j++;
                }
                if(find === false){
                    arrayDelete.push(movimiento)
                }

            }
        }

        console.log('ARRAY DELETE: ', arrayDelete)
        if(arrayDelete.length > 0){
            arrayDelete.forEach((ROW)=>{
                this.deleteporItemInexistente(ROW)
            })
        }
    }

    deleteporItemInexistente(movimiento){
        for(var i = 0; i < this.state.doc_pendientes.length ; i++){
            console.log('MOV PARAM: ', movimiento, 'ARRAY MOV: ', this.state.doc_pendientes[i].Movimiento) 
            if(movimiento === this.state.doc_pendientes[i].Movimiento){
                this.state.doc_pendientes.splice(i, 1);
            }
        }
    }

    asignarFactrepetidas(array){
        var errorString = "";
        array.forEach((a)=>{
            errorString = errorString.concat(String(a+", "));
        })
        return errorString;
    }

    changePermisosButtons(permiso1, permiso2, permiso3){

        this.setState({ recaudador: permiso1 });//Guardar
        this.setState({ cartera: permiso2 });
        this.setState({ cobro: permiso3 });//Limpiar
    }

    validacionDistribucion(){
        console.log('T RECIBIDOS: ', this.state.total_recibidos, 'T total PG:', this.state.total_DISPG, 'T DP APL:', this.state.total_aplicado_DP);
        if(this.state.total_recibidos !== this.state.total_DISPG){
            alert("El total de la aplicación del recibo no es igual al valor recibido")
        }else if(this.state.total_recibidos !== this.state.total_aplicado_DP){
            alert("El total de la aplicación del recibo no es igual al valor recibido")
            this.setState({grid_distribucionpago: [], total_DISPG: 0})
        }
    }

    SumarFecha(fechaInput, dias){
        var fechaparts = fechaInput.split("/");
        var fch_sist_ = new Date(parseInt(fechaparts[2],10), parseInt(fechaparts[1],10)-1, parseInt(fechaparts[0],10))
        var fecha = fch_sist_;

        var dayOfMonth = fecha.getDate();
        fecha.setDate(dayOfMonth + dias);

        return fecha;
    }

    StringtoDate(fecha){
        var StringDate = fecha;
        var fechapartes = StringDate.split("/");
        return  new Date(parseInt(fechapartes[0],10), parseInt(fechapartes[1],10)-1, parseInt(fechapartes[2],10));
    }

    //Control de registro de fechas del vendedor
    validacionCheques(){
        let days = this.state.paramDiasRetroDoc!==null?parseInt(this.state.paramDiasRetroDoc.value,10):10;
        var fecha_recibo = this.SumarFecha(this.props.fecha_recibo,(days*-1));
        var Error_fechas = [];
        var Error_columnas = [];
        var Error_repetidas = [];
        var Error_reingreso = [];
        var Error_fechasMAX = [];

        let chequeAlert = false;
        
        console.log('Entro a validacionCheques')
        this.state.grid_valores_recibidos.forEach((VR, i)=>{
            if(parseInt(VR.Forma_Pago, 10)===1 || parseInt(VR.Forma_Pago, 10)===2 || parseInt(VR.Forma_Pago, 10)===6){
                
                var fecha_cheq = VR.Vencimiento_cheq                

                var fecha_cheq_parts = fecha_cheq.split("/");
                var fecha_vencimiento = new Date(parseInt(fecha_cheq_parts[2],10), parseInt(fecha_cheq_parts[1],10)-1, parseInt(fecha_cheq_parts[0],10))

                console.log('COMPARACION GETTIME: ', fecha_vencimiento.getTime() < fecha_recibo.getTime())
                if(fecha_vencimiento.getTime() < fecha_recibo.getTime() ){
                    
                    /* Cuando es cheque al día */
                    if(parseInt(VR.Forma_Pago, 10)===1){
                        console.log('CHEQUE DIA: ', VR.Cheque)
                        /* Calculo de semana para cheque al día */
                        let start = moment(this.props.fecha_recibo ,'DD/MM/YYYY').startOf('isoWeek').subtract(1, 'days');
                        let end = moment(this.props.fecha_recibo,'DD/MM/YYYY').endOf('isoWeek').add(1, 'days');
                        let fechaCheque = moment(VR.Vencimiento_cheq, 'DD/MM/YYYY');

                        let ChqueDiaValid = fechaCheque.isBetween(start ,end)

                        /* Validacion para verificar el mes de la fecha */
                        let monthfechaCheque = fechaCheque.format('M');
                        let monthfechaRecibo = moment(this.props.fecha_recibo ,'DD/MM/YYYY').format('M');
                        console.log('CHQ VALID: ', ChqueDiaValid)
                        if(ChqueDiaValid===true){
                            /* Validacion para verificar la fecha del mes escogida esta dentro del mismo mes del recibo */
                            if(monthfechaCheque!==monthfechaRecibo){
                                Error_fechas = Error_fechas.concat(String((VR.Cheque).trim()+", "));
                                //this.setState({cheq_alert: true});
                                chequeAlert = true;
                                console.log('CASO FECHA INVALIDA') 
                            }                            
                        }else if(monthfechaCheque!==monthfechaRecibo){
                            Error_fechas = Error_fechas.concat(String((VR.Cheque).trim()+", "));
                            //this.setState({cheq_alert: true});
                            chequeAlert = true;
                            console.log('CASO FECHA INVALIDA') 
                            
                        }else{
                            /* Error cuando un cheque no entra en la categoria chq dia (Validacion de CHQ Dia) */
                            Error_fechas = Error_fechas.concat(String((VR.Cheque).trim()+", "));                    
                            //this.setState({cheq_alert: true});
                            chequeAlert = true;
                            console.log('FUERA DE CATEGORIA CHEQUE DIA') 
                        }
                    }else{
                        /* Cuando no es cheque al día */
                        console.log('CUANDO NO ES CHEQUE AL DÏA');
                        Error_fechas = Error_fechas.concat(String((VR.Cheque).trim()+", "));                    
                        //this.setState({cheq_alert: true});
                        chequeAlert = true;
                    }
                    
                }else{
                    /* Indicación de que la fecha del cheque es SUPERIOR A LA FECHA DEL RECIBO */
                    let fechaVencimiento = moment(VR.Vencimiento_cheq , 'DD/MM/YYYY');
                    let fechaRecibo = this.state.fechaRecibo;

                    switch (parseInt(VR.Forma_Pago,10)){
                        case 1:
                            /* Cuando es cheque al día */
                            console.log('CHEQUE DIA NEW WAVE: ', VR.Cheque)
                            /* Calculo de semana para cheque al día */
                            let start = moment(this.props.fecha_recibo ,'DD/MM/YYYY').startOf('isoWeek').subtract(1, 'days');
                            let end = moment(this.props.fecha_recibo,'DD/MM/YYYY').endOf('isoWeek').add(1, 'days');
                            let fechaCheque = moment(VR.Vencimiento_cheq, 'DD/MM/YYYY');

                            console.log('FECHA START: ', formatearFechaMoment_a_String(start), 'FECHA END: ',formatearFechaMoment_a_String(end) )
                            let ChqueDiaValid = fechaCheque.isBetween(start ,end)

                            /* Validacion para verificar el mes de la fecha */
                            let monthfechaCheque = fechaCheque.format('M');
                            let monthfechaRecibo = moment(this.props.fecha_recibo ,'DD/MM/YYYY').format('M');

                            if(ChqueDiaValid===true){
                                /* Validacion para verificar la fecha del mes escogida esta dentro del mismo mes del recibo */
                                // if(monthfechaCheque!==monthfechaRecibo){
                                //     Error_fechas = Error_fechas.concat(String((VR.Cheque).trim()+", "));
                                //     //this.setState({cheq_alert: true});
                                //     chequeAlert = true;
                                //     console.log('CASO FECHA INVALIDA') 
                                // }                            
                            }else if(monthfechaCheque!==monthfechaRecibo){
                                Error_fechas = Error_fechas.concat(String((VR.Cheque).trim()+", "));
                                //this.setState({cheq_alert: true});
                                chequeAlert = true;
                                console.log('CASO FECHA INVALIDA') 
                            }
                            
                            break;
                        case 6:
                            /* CHQ MES */
                            if(/*fechaVencimiento.format('M') !== fechaRecibo.format('M') ||*/ fechaRecibo.format('Y') !== fechaVencimiento.format('Y')){
                                Error_fechasMAX = Error_fechasMAX.concat(String((VR.Cheque).trim()+", "));
                                chequeAlert = true;
                            }
                            break;
                        default:
                            break;
                    }
                }

                if(!VR.hasOwnProperty('Banco') || !VR.hasOwnProperty('Cuenta') || !VR.hasOwnProperty('Cheque')){
                    //this.setState({cheq_alert: true});
                    chequeAlert = true;
                    Error_columnas = Error_columnas.concat(String((VR.Cheque).trim()+", "));
                }

                //Validacion cheques repetidos
                var temp = {};
                temp = this.chequesRepetidos(VR.Banco , VR.Cuenta, VR.Cheque );
                if(temp.length > 0){
                    Error_repetidas = Error_columnas.concat(String((VR.Cheque).trim()+", "));
                }

                //Validacion Caso Cheques ya ingresados
                var tempo = "";
                tempo = this.chequesReIngresados(VR.Banco, VR.Cuenta, VR.Cheque, VR.estadoCh)
                if(tempo !== undefined){
                    Error_reingreso = Error_reingreso.concat(String(( tempo )+", \n"));
                }
            }
        })

        //ERROR FECHAS
        if(Error_fechas.length > 0){
            alert("Los cheques #:"+Error_fechas+" tienen una fecha de vencimiento menor a la fecha del recibo: "+this.state.recibo);
        }

        //ERROR FECHAS DESFASADO
        if(Error_fechasMAX.length > 0){
            alert("Los cheques #:"+Error_fechasMAX+" tienen una fecha de vencimiento incorrecta a la forma de pago");
        }

        //ERROR Columnas incompletas
        if(Error_columnas.length > 0){
            alert("Los cheques #:"+Error_columnas+" se encuentran repetidos en el grid");
        }
        //ERROR Cheques repetidos
        if(Error_repetidas.length > 0){
            alert("Los cheques #:"+Error_repetidas+" estan repetidos dentro de valores recibidos");
        }

        if(Error_reingreso.length > 0){
            alert(Error_reingreso);
        }

        // if(Error_fechas.length === 0 && Error_columnas.length === 0 && Error_repetidas.length === 0 && Error_reingreso.length === 0){
        //     this.setState({cheq_alert: false, recaudador: false});
        // }
        
        if(chequeAlert === true){
            this.setState({cheq_alert: true, recaudador: true});
        }else if(chequeAlert === false){
            this.setState({cheq_alert: false, recaudador: false});
        }
    }

    //Cheques repetidos en el grid
    chequesRepetidos(banco, cuenta, num_doc){
        var result = {};
        var VR = this.props.Val_recibidos;
        for(var index = 0; index < VR.length; index++){
            if(parseInt(VR.Forma_Pago, 10)===1 || parseInt(VR.Forma_Pago, 10)===2 || parseInt(VR.Forma_Pago, 10)===6){
                if(banco===VR.Banco && cuenta===VR.Cuenta && num_doc===VR.Cheque){
                    result.Cheque = VR.Cheque;
                    break;
                }
            }
        }
        
        return result;
    }

    //Cheque ya ingresados
    chequesReIngresados(banco, cuenta, num_doc, estado){
        var mensaje = "";        
        var op = "";
        if(estado!==null){
            op = String(estado).trim();
            if(op==='X' || op==='x'){
                this.setState({exist_chq_protestados: true});
            }

            switch (op){                
                case 'P':
                    this.setState({cheq_alert: true});
                                                   
                    mensaje = "El cheque #: "+num_doc+" del banco "+banco+" con cuenta "+cuenta+" ya fue ingresado con estado de pendiente";
                    return mensaje;
    
                case 'D':
                    this.setState({cheq_alert: true});
                    mensaje = "El cheque #: "+num_doc+" del banco "+banco+" con cuenta "+cuenta+" ya fue ingresado con estado de depositado";
                    return mensaje;                
    
    
                case 'A':
                    this.setState({cheq_alert: true});
                    mensaje = "El cheque #: "+num_doc+" del banco "+banco+" con cuenta "+cuenta+" ya fue ingresado con estado de anulado";
                    return mensaje;                
    
    
                case 'J':
                    this.setState({cheq_alert: true});
                    mensaje = "El cheque #: "+num_doc+" del banco "+banco+" con cuenta "+cuenta+" ya fue ingresado con estado de canjeado";
                    return mensaje;  
            
                default:
                    break;
            }
        }
    }

    distribuirDocsPendientesRET(){
        var grid_distribucion = [];
        var valor_recibido  = 0;
        var valor_pendiente = 0;
        var index_pendiente = 0;
        var total_distribucion= 0;
        var FP = 0;
        
        var sec = 0;

        //console.log('GRID VALORES RECIBIDOS: ', this.state.grid_valores_recibidos)
        //console.log('GRID DOCS PENDIENTES: ', this.state.grid_docs_pendientes)

        for(var index_recibido= 0; index_recibido < this.state.grid_valores_recibidos.length; index_recibido++ ){
            //console.log('VUELTA: ', index_recibido)
            valor_recibido = this.state.grid_valores_recibidos[index_recibido].ValorRecaudado;
            FP = parseInt(this.state.grid_valores_recibidos[index_recibido].Forma_Pago, 10);
            //console.log('valor_recibido: ', valor_recibido, 'FP: ', FP);
            while(valor_recibido > 0 && FP!==7){
                //console.log('1.0 tamaño grid pendiente > index_pendiente', this.state.grid_docs_pendientes.length > index_pendiente)
                if(this.state.grid_docs_pendientes.length > index_pendiente){

                    //console.log('2.0 valor_recibido >= DP.ValAplicar: ', valor_recibido >= this.state.grid_docs_pendientes[index_pendiente].val_aplicar, ' valor_recibido: ',valor_recibido, ' DP.ValAplicar: ',this.state.grid_docs_pendientes[index_pendiente].val_aplicar)
                    if(valor_recibido >= this.state.grid_docs_pendientes[index_pendiente].val_aplicar){
                        //console.log('3.0 this.state.grid_docs_pendientes[index_pendiente].val_aplicar > 0: ',this.state.grid_docs_pendientes[index_pendiente].val_aplicar > 0)
                        if(this.state.grid_docs_pendientes[index_pendiente].val_aplicar > 0){
                            
                            var item = {};
                            item.secuencia = ++sec;
                            item.sec_VR = this.state.grid_valores_recibidos[index_recibido].secuencia;
                            item.forma_pago = this.state.grid_valores_recibidos[index_recibido].DescripcionPago;
                            item.documento = (this.state.grid_valores_recibidos[index_recibido].Cheque).trim();
                            item.tipo_doc = this.state.grid_docs_pendientes[index_pendiente].Tipo_Transaccion;
                            item.num_doc =  this.state.grid_docs_pendientes[index_pendiente].Movimiento;
                            item.valor = 
                            Math.round(this.state.grid_docs_pendientes[index_pendiente].val_aplicar * 100) / 100;
                            total_distribucion = total_distribucion + Math.round(this.state.grid_docs_pendientes[index_pendiente].val_aplicar * 100) / 100;
                            item.fecha = this.state.grid_valores_recibidos[index_recibido].Vencimiento_cheq;
                            item.vendedor = this.state.grid_docs_pendientes[index_pendiente].Vendedor;
                            valor_recibido = Math.round((valor_recibido - this.state.grid_docs_pendientes[index_pendiente].val_aplicar)*100)/100;
                            //console.log('\nINSERT 3.0: ', item)
                            grid_distribucion.push(item);
                        }
                        index_pendiente++;  
                        //console.log('ACTUALIZA INDEX PENDIENTE: ', index_pendiente)
                    }else{
                        //console.log('2.0 (FALSE) valor_recibido >= DP.ValAplicar: ', valor_recibido >= this.state.grid_docs_pendientes[index_pendiente].val_aplicar, ' valor_recibido: ',valor_recibido, ' DP.ValAplicar: ',this.state.grid_docs_pendientes[index_pendiente].val_aplicar)
                        valor_pendiente = this.state.grid_docs_pendientes[index_pendiente].val_aplicar;
                        //console.log('valor_pendiente: ', valor_pendiente, 'index_pendiente: ', index_pendiente)
                        
                        while(valor_pendiente > 0){
                            if(FP===7){
                                index_recibido = index_recibido + 1;
                                valor_recibido = this.state.grid_valores_recibidos[index_recibido].ValorRecaudado;
                                FP = parseInt(this.state.grid_valores_recibidos[index_recibido].Forma_Pago, 10);
                                continue;
                            }

                            //console.log('2.1.0 while pendiente: ', valor_pendiente)
                            //console.log('2.1.0 valor_pendiente >= valor_recibido', valor_pendiente >= valor_recibido , valor_pendiente, valor_recibido)
                            if(valor_pendiente >= valor_recibido){
                                //console.log('index_recibido: ', index_recibido, 'index_pendiente: ', index_pendiente)
                                let item = {};                                
                                item.secuencia = ++sec;
                                item.sec_VR = this.state.grid_valores_recibidos[index_recibido].secuencia;
                                item.forma_pago = this.state.grid_valores_recibidos[index_recibido].DescripcionPago;
                                item.documento = (this.state.grid_valores_recibidos[index_recibido].Cheque).trim();
                                item.tipo_doc = this.state.grid_docs_pendientes[index_pendiente].Tipo_Transaccion;
                                item.num_doc =  this.state.grid_docs_pendientes[index_pendiente].Movimiento;
                                item.valor = Math.round(valor_recibido * 100) / 100;

                                total_distribucion = total_distribucion + Math.round(valor_recibido * 100) / 100;
                                
                                
                                item.fecha = this.state.grid_valores_recibidos[index_recibido].Vencimiento_cheq;
                                item.vendedor = this.state.grid_docs_pendientes[index_pendiente].Vendedor;

                                valor_pendiente = (valor_pendiente - valor_recibido)

                                if(valor_pendiente === 0){
                                    index_pendiente++;
                                }

                                if(this.state.grid_valores_recibidos.length > index_recibido){
                                    valor_recibido = this.state.grid_valores_recibidos[index_recibido].ValorRecaudado;
                                }

                                //console.log('VALOR A APLICAR: ', item.valor)
                                //console.log('2.1.0 (TRUE)->INSERT: ', item)
                                grid_distribucion.push(item);
                                //console.log('CASO ERROR RESULTADO: ', valor_pendiente, ' FP: ', FP, ' VALOR APLICADO: ',item.valor)
                                //console.log('VALUE OF TRUTH: ', !(this.state.grid_valores_recibidos.length === index_recibido + 1), ' INDEX VR TOTAL: ',this.state.grid_valores_recibidos.length, ' INDEX RECIBIDO + 1: ',index_recibido + 1)
                                
                                //console.log('VR LEN: ', this.state.grid_valores_recibidos.length, 'INDEX_RECIBIDO: ', index_recibido )
                                if( (!(this.state.grid_valores_recibidos.length === index_recibido + 1))===true ){
                                    //console.log('ENTRO A SIGUIENTE VR')
                                    index_recibido = index_recibido + 1;                                      
                                    //console.log('TAMAÑO SOBRE VR INDEX RECIBIDO: ', this.state.grid_valores_recibidos.length , index_recibido)
                                    valor_recibido = this.state.grid_valores_recibidos[index_recibido].ValorRecaudado;
                                    FP = parseInt(this.state.grid_valores_recibidos[index_recibido].Forma_Pago, 10);
                                }
                                
                            }else{
                                //console.log('2.1.0(FALSE)-> valor_pendiente >= valor_recibido')
                                // eslint-disable-next-line
                                var index_anterior
                                //console.log('INDEX ANTERIOR CONTROL: ', index_recibido === this.state.grid_valores_recibidos.length)
                                if(index_recibido === this.state.grid_valores_recibidos.length){
                                    index_anterior = index_recibido;
                                    index_recibido = index_recibido - 1;
                                }
                                
                                let item = {};
                                item.secuencia = ++sec;
                                item.sec_VR = this.state.grid_valores_recibidos[index_recibido].secuencia;
                                item.forma_pago = this.state.grid_valores_recibidos[index_recibido].DescripcionPago;
                                item.documento = (this.state.grid_valores_recibidos[index_recibido].Cheque).trim();
                                item.tipo_doc = this.state.grid_docs_pendientes[index_pendiente].Tipo_Transaccion;
                                item.num_doc =  this.state.grid_docs_pendientes[index_pendiente].Movimiento;
                                //console.log('valor pendiente antes asignar a grid: ', valor_pendiente)
                                item.valor = Math.round(valor_pendiente * 100) / 100;
                                
                                item.fecha = this.state.grid_valores_recibidos[index_recibido].Vencimiento_cheq;
                                item.vendedor = this.state.grid_docs_pendientes[index_pendiente].Vendedor;

                                total_distribucion = total_distribucion + Math.round(valor_pendiente * 100) / 100;
                                
                                //console.log('valor pendiente antes resta: ', valor_pendiente)
                                valor_recibido = Math.round((valor_recibido - valor_pendiente)*100)/100;
                                valor_pendiente = 0.00;
                                index_pendiente++;
                                
                                //console.log('2.1.0(FALSE)->VALOR: ', item.valor )
                                //console.log('2.1.0(FALSE)->INSERT: ', item)
                                if(item.valor > 0){
                                    grid_distribucion.push(item);
                                }
                            }

                        };
                    }
                }else{
                    //console.log('1.0 (FALSE) tamaño grid pendiente > index_pendiente', this.state.grid_docs_pendientes.length > index_pendiente)
                    valor_pendiente = 0.00;
                    valor_recibido = 0.00;
                }
            }
        }

        //console.log('============== AGREGACION DE RETENCIONES ==================\n\n')
        //Agregacion RETENCIONES
        var VR = this.state.grid_valores_recibidos;
        for(var index = 0; index < VR.length; index++ ){
            if(parseInt(VR[index].Forma_Pago, 10) === 7){
                //console.log('Fila a atratar: ', VR[index])
                var item_ret = {};
                var AccRetencionValor = 0;
                //console.log('Fila RET a PROCESAR: ', index+1)
                item_ret.secuencia = ++sec;
                item_ret.sec_VR = this.StealerFunc(VR[index].Cheque, this.state.grid_valores_recibidos, "Cheque", 7, "secuencia")
                item_ret.forma_pago = VR[index].DescripcionPago;
                item_ret.documento = (VR[index].Cheque).trim();
                item_ret.num_doc =  VR[index].fac_ret;
                item_ret.tipo_doc = 'FAC';
                item_ret.valor = Math.round(VR[index].ValorRecaudado*100)/100;
                //console.log('VALOR PRUEBA : ', Math.abs(Math.round(VR[index].ValorRecaudado*100)/100))

                AccRetencionValor = AccRetencionValor + item_ret.valor;
                //console.log('INDICADOR EN VR: ', VR[index].Indicador, 'Vuelta: ', index)
                if(VR[index].Indicador === 0){
                    var resul_eval = 0.00;
                    resul_eval = this.verificarRetencionesToDP(VR[index].fac_ret)                    
                    item_ret.valor = resul_eval;
                }
                //console.log('VR.RETValor: ',  item_ret.valor)

                item_ret.fecha = VR[index].Vencimiento_cheq;
                total_distribucion = total_distribucion + AccRetencionValor;
                grid_distribucion.push(item_ret);
            }
        }
        
        this.setState({grid_distribucionpago: grid_distribucion, total_DISPG: Math.round(total_distribucion * 100)/ 100});        
        //console.log('GRID DISTRIBUCION PAGO: ', grid_distribucion)
    }

    StealerFunc(searchPattern, ArraySerch, columnToSerch, typeToSerch, columnRetrive ){
        var response;
        ArraySerch.forEach((array)=>{
            if(parseInt(array.Forma_Pago, 10) === typeToSerch){
                if(array[columnToSerch] ===  searchPattern){
                    response = array[columnRetrive];
                }  
            }
        })
        return response;
    }

    /*
        searchPattern => patron de busqueda     (String)
        ArraySerch    => array a buscar         (ARRAY)
        columnToSerch => columna a buscar       (STRING)
        columnRetrive => columna a retornar     (STRING)
    */
    StealerFuncSinTipo(searchPattern, ArraySerch, columnToSerch, columnRetrive ){
        var response;
        ArraySerch.forEach((array)=>{
            if(array[columnToSerch] ===  searchPattern){
                response = array[columnRetrive];                
            }              
        })
        return response;
    }

    verificarRetencionesToDP(num_factura){
        var DP;
        var result = 0.00;
        DP = this.state.grid_docs_pendientes;
        DP.forEach((DP)=>{
            console.log('param fact: ', num_factura, ' DP MOV: ', DP.Movimiento, ' Comparacion: ',num_factura === DP.Movimiento)
            if(num_factura === DP.Movimiento){
                if(DP.retencion > 0){
                    result = DP.retencion
                }
            }
        })
        
        return result;

    }

    //Asignacion valores distribuidos SIN RETENCION
    setValoresDistribuidosOnlyChques(Val_recibidos){

        console.log("Distribucion Auto cheque!!!!!", Val_recibidos);
        var grid_distribucion = [];
        var valor_recibido= 0.00;
        var valor_aplicado= 0.00;
        var index_aplicado= 0;        
        var total_distribucion= 0.00;
        let counter = 0;
        var sec = 0;
        
        
        //if(this.state.super === false){
            console.log('GRID VALORES RECIBIDOS: ', this.state.grid_valores_recibidos)
            console.log('GRID DOCS PENDIENTES: ', this.state.grid_docs_pendientes)
            
            for(var index_recibido= 0; index_recibido < Val_recibidos.length; index_recibido++ ){
                console.log('FILA: ', Val_recibidos[index_recibido])
                valor_recibido = Val_recibidos[index_recibido].ValorRecaudado;
                console.log('VUELTA: ', index_recibido, 'VALOR RECIBIDO: ', valor_recibido)
                while(valor_recibido > 0){
                   
                    console.log('INDEX: ', index_aplicado, 'CONDICION: ', this.state.grid_valores_aplicados.length > index_aplicado)
                    if(this.state.grid_valores_aplicados.length > index_aplicado){
                        console.log('LADO TRUE: =>INDEX APLICADO: ', index_aplicado, 'VALOR APLICADO: ', this.state.grid_valores_aplicados[index_aplicado].valor)
                        console.log('CONDICION 2: ', valor_recibido >= this.state.grid_valores_aplicados[index_aplicado].valor)
                        if(valor_recibido >= this.state.grid_valores_aplicados[index_aplicado].valor){
                            
                            var item = {};
                            item.secuencia = ++sec;
                            item.recibo = this.state.recibo;
                            item.forma_pago = Val_recibidos[index_recibido].DescripcionPago;
                            item.sec_VR = Val_recibidos[index_recibido].secuencia;
                            item.documento = (Val_recibidos[index_recibido].Cheque).trim();
                            item.tipo_doc = this.state.grid_valores_aplicados[index_aplicado].Tipo_Transaccion;
                            item.num_doc =  this.state.grid_valores_aplicados[index_aplicado].Movimiento;
                            item.valor = 
                            Math.round(this.state.grid_valores_aplicados[index_aplicado].valor * 100) / 100;
                            
                            total_distribucion = total_distribucion + Math.round(this.state.grid_valores_aplicados[index_aplicado].valor * 100) / 100;
                  
                            item.fecha = Val_recibidos[index_recibido].Vencimiento_cheq;
                            item.vendedor = this.state.grid_valores_aplicados[index_aplicado].Vendedor;
        
                            //Calculo
                            valor_recibido = (valor_recibido - this.state.grid_valores_aplicados[index_aplicado].valor);
                            
                            index_aplicado++;                            
                            grid_distribucion.push(item);
                            
                        }else{
                            
                            valor_aplicado = this.state.grid_valores_aplicados[index_aplicado].valor;
                            console.log('VALOR RECIBIDO < A VALOR APLICADO')
                            console.log('VALOR APLICADO A RESTAR', valor_aplicado)
                            
                            while(valor_aplicado > 0){
                                console.log('VUELTA WHILE: ', counter, 'VALOR APLICADO: ', valor_aplicado)
                                counter++
                                console.log('================================ ERROR AREA ===========================================')
                                console.log('VALOR APLICADO >= VALOR RECIBIDO: ', valor_aplicado >= valor_recibido)
                                if(valor_aplicado >= valor_recibido){
                                    let item = {};
                                    
                                    item.secuencia = ++sec;
                                    item.recibo = this.state.recibo;
                                    item.forma_pago = Val_recibidos[index_recibido].DescripcionPago;
                                    item.sec_VR = Val_recibidos[index_recibido].secuencia;
                                    item.documento = (Val_recibidos[index_recibido].Cheque).trim();
                                    item.tipo_doc = this.state.grid_valores_aplicados[index_aplicado].Tipo_Transaccion;
                                    item.num_doc =  this.state.grid_valores_aplicados[index_aplicado].Movimiento;
                                    item.valor = Math.round(valor_recibido * 100) / 100;
                                    
                                    total_distribucion = total_distribucion + Math.round(valor_recibido * 100) / 100;                                    
                                    
                                    item.fecha = Val_recibidos[index_recibido].Vencimiento_cheq;
                                    item.vendedor = this.state.grid_valores_aplicados[index_aplicado].Vendedor;
        
                                    valor_aplicado = (valor_aplicado - valor_recibido)
                                    console.log('VALOR APLICADO RESTADO: ', valor_aplicado , 'VR: ',valor_recibido)
                                    if(valor_aplicado === 0){
                                        console.log('AUMENTO A SIGUIENTE INDEX APLICADO: ', index_aplicado)
                                        index_aplicado++;
                                    }
                                    console.log('Val_recibidos.length > index_recibido: ', index_recibido <= Val_recibidos.length, 'Val_recibidos.length: ', Val_recibidos.length-1, 'index_recibido: ', index_recibido)
                                    if(index_recibido < Val_recibidos.length-1){
                                        index_recibido++;
                                        console.log('ACTUALIZA VALOR RECIBIDO: ', Val_recibidos[index_recibido].ValorRecaudado, 'INDEX_RECIBIDO: ', index_recibido)
                                        valor_recibido = Val_recibidos[index_recibido].ValorRecaudado;
                                    }else{
                                        /* PARA ULTIMA FILA */
                                        console.log('ULKTIMA FILA') 
                                        valor_recibido = Val_recibidos[index_recibido].ValorRecaudado;
                                    }

                                    console.log('valor_aplicado: ', valor_aplicado, 'index_aplicado: ', index_aplicado)

                                    grid_distribucion.push(item);
                                    
                                    //index_recibido = index_recibido + 1;
                                    //ADICION BETA POR CORRECCION DE BUG MODO 
                                    // if(index_recibido<= Val_recibidos.length){
                                    //     console.log("NEXT CH: ", Val_recibidos[index_recibido].ValorRecaudado)
                                    //     valor_recibido = Val_recibidos[index_recibido].ValorRecaudado;
                                    // }   25474                             
                                    
                                }else{    
                                    // eslint-disable-next-line                                
                                    var index_anterior
                                    if(index_recibido === Val_recibidos.length){
                                        index_anterior = index_recibido;
                                        index_recibido = index_recibido - 1;
                                    }


                                    valor_recibido = Val_recibidos[index_recibido].ValorRecaudado;
                                    
                                    let item = {};
                                    item.secuencia = ++sec;
                                    item.recibo = this.state.recibo;
                                    item.forma_pago = Val_recibidos[index_recibido].DescripcionPago;
                                    item.sec_VR = Val_recibidos[index_recibido].secuencia;
                                    item.documento = (Val_recibidos[index_recibido].Cheque).trim();
                                    item.tipo_doc = this.state.grid_valores_aplicados[index_aplicado].Tipo_Transaccion;
                                    item.num_doc =  this.state.grid_valores_aplicados[index_aplicado].Movimiento;
                                    item.valor = Math.round(valor_aplicado * 100) / 100;                                    
                                    item.fecha = Val_recibidos[index_recibido].Vencimiento_cheq;
                                    item.vendedor = this.state.grid_valores_aplicados[index_aplicado].Vendedor;
        
                                    total_distribucion = total_distribucion + Math.round(valor_aplicado * 100) / 100;
                                    
                                    valor_recibido = (valor_recibido - valor_aplicado);
                                    valor_aplicado = 0.00;
                                    index_aplicado++;
        
                                    if(item.valor > 0){
                                        grid_distribucion.push(item);
                                    }
                                    console.log('valor_aplicado: ', valor_aplicado, 'index_aplicado: ', index_aplicado)
                                }
        
                            };//END while - Valor_aplicado
                        }
                    }else{
                        valor_aplicado = 0.00;
                        valor_recibido = 0.00;
                    }
                };//END while - Valor_recibido
            }
        
        this.setState({grid_distribucionpago: grid_distribucion, total_DISPG: Math.round(total_distribucion * 100) / 100},()=>{
            this.validacionDistribucion();
        });
    }

    getFactura(pemision, generada){
        let config_request = {
            method: 'GET',
            url:'/facturas?pemision='+pemision+'&generada='+generada
        }
        return new Promise((resolve, reject) => {
            global_axios(config_request)
            .then((response)=>{
                resolve(response.data);
            })
            .catch(function(error){ 
                reject(error);   
            })
        })
    }

    getValDocuments(array ,serch){
        var VA = array;
        var result = {}
        for(var i = 0; i< VA.length; i++){
            if(VA[i].Movimiento === serch ){
                result.tipo = VA[i].Tipo_Transaccion;
                result.fecha = VA[i].fecha_documento;               
                result.saldo = VA[i].saldo;
                result.valor_original = VA[i].valor_original;
                if(VA[i].hasOwnProperty('vendedor')){
                    result.vendedor = VA[i].vendedor;
                }

                break;
            }
        }        
        return result;
    }

    getValidacionFactura(pemision, generada, cliente, recibo){
        let config_request = {
            method: 'GET',
            url: '/facturas/pemision/'+pemision+'/generada/'+generada+'/cliente/'+cliente+'/recibo/'+recibo,
        }
        return new Promise((resolve, reject) => {
            global_axios(config_request)
            .then((response)=>{                
                resolve(response.data);
            })
            .catch(function(error){ 
                reject(error);   
            })
        })
    }

    getParametrosCobranza(){
        return cargarParametros("COBRANZA&cadena_busq_cobranza=RET", 'tabla');
    }

    getCobranza(){
        this.limpiarPantalla('B'); 
        let fechaProceso = getFechaProcesoPorModulo('05');
        
        if(this.state.recibo === ''){
            alert("Digite un recibo");
        }else if(parseInt(this.state.periodo,10) < 0 || this.state.periodo==='' ){
            alert("Recibo no válido");
        }else{                       
            var recibo = this.state.recibo;
            this.props.cargar_Cobranza_a_Editar(recibo).then(()=>{                
                
                if(this.props.recibo_estado==='P'){                    
                    //Valores recibidos
                    
                    var totalRecibidoDocs = 0;
                    
                    //Validacion por valor recibido
                    let errorEfectivos = '';
                    this.props.Val_recibidos.forEach((VA)=>{
                        
                        if(parseInt(VA.Forma_Pago,10)!==7){
                            totalRecibidoDocs = totalRecibidoDocs + parseFloat(VA.ValorRecaudado,10)
                        }

                        if(parseInt(VA.Forma_Pago,10)===3 || parseInt(VA.Forma_Pago,10)===8){
                            console.log('FILA: ', VA)
                            if(VA.Cheque==='' || VA.Vencimiento_cheq===''){
                                errorEfectivos+=`- Ingrese número de documento o fecha de depósito de la forma de pago ${VA.secuencia}\n`
                            }
                        }
                    })

                    if(errorEfectivos!==''){
                        this.setState({efectivo_alert: true})
                        alert(errorEfectivos);                        
                    }                    
                    
                    var total_VR = parseFloat(this.props.Total_recibido===null?0:this.props.Total_recibido);
                    var total_ret = parseFloat(this.props.Total_ret===null?0:this.props.Total_ret);
                    var total_VA = parseFloat(this.props.Total_aplicados===null?0:this.props.Total_aplicados);
                    
                    var result = 0.00;
                    result = (Math.round(total_VR * 100) / 100 + Math.round(total_ret * 100) / 100) -  Math.round(total_VA * 100) / 100;
                    
                    let existenDocsPend = false;

                    //Documentos Pendientes sin retencion
                    if(this.props.ret_exist === false && this.props.cash_dpto_exist === false && (result ===0 || result === 0.00)){
                        var DP = [];
                        DP = this.docPendientesSinRetencion(this.props.Val_aplicados, this.props.Val_recibidos);
                        this.setState({ grid_docs_pendientes: DP, 
                                        total_saldo_recibido: this.props.Total_saldo_p,
                                        operacion_incompleta: DP.length===0?true:false
                                    });

                        //Comprueba transaccion
                        if(DP.length === 0){                            
                            alert("Ingrese con clave de supervisor.")
                        }else{
                            existenDocsPend=true;
                        }

                    }else if(this.props.ret_exist === false && this.props.cash_dpto_exist === false && (result > 0 || result < 0.00)){
                        alert("No se han aplicado los valores recibidos en su totalidad, diferencia: "+Math.round(result * 100) / 100);
                        this.setState({sobre_pago: true});
                    }

                    this.setState({ recibo_estado: this.props.recibo_estado, 
                        recaudador_sel: this.props.recaudador,
                        cliente_sel: this.props.cliente, 
                        vendedor_sel: this.props.vendedor, 
                        fechaRecibo: moment(this.props.fecha_recibo, 'DD/MM/YYYY'),
                        observacion_vendedor: this.props.observacion_vendedor?this.props.observacion_vendedor:'',
                        grid_valores_recibidos: this.props.Val_recibidos,
                        recaudador: false,
                        cartera: false,
                        cobro: false,
                        total_recibidos: Math.round(totalRecibidoDocs * 100)/100,
                        total_retencion: Math.round((this.props.Total_ret===null?0:this.props.Total_ret) * 100)/100,
                        c_total_recibo: this.props.total_recibo,
                        grid_valores_aplicados: this.props.Val_aplicados, //valores aplicados
                        total_aplicacion: Math.round(this.props.Total_aplicados * 100)/100,
                        diferenciaVA: Math.round((this.props.total_recibo - this.props.Total_aplicados)*100)/100,
                    });

                    //Valores distribuidos
                    if(existenDocsPend ===true && (this.props.ret_exist === false && this.props.cash_dpto_exist=== false)){//Caso 1 if carga
                        
                        this.setValoresDistribuidosOnlyChques(this.props.Val_recibidos);
                        //this.validacionDistribucion();
                        //ADICION PARA PERMITIR RECALCULAR LOS CHEQUES
                        this.setState({boton_distribuir: false, boton_aplicar_distribucion: false});                        
                    }

                    console.log('RET EXIST: ', this.props.ret_exist, 'DPTO: ', this.props.cash_dpto_exist)
                    if(this.props.ret_exist === true && this.props.cash_dpto_exist=== false){                        
                        this.setState({boton_distribuir: false});
                    }
                    
                    this.validacionCheques();
          
                    //Validacion buttons por cheques ya ingresados (EXCEPTO PROTESTADO 'X')
                    if(this.state.cheq_alert === true){                    
                        this.setState({recaudador: true,  cartera: true, cobro: true});
                    }                   

                    if(this.state.sobre_pago === true){
                        //Activa boton Aplicar Distribucion
                        this.setState({boton_aplicar_distribucion: false, boton_distribuir: false});
                    }                    

                }else if(this.props.recibo_estado==='G'){
                    console.log('LIBRO DIARIO: ', this.props.Val_libroDiario)
                    
                    //Valores recibidos
                    this.setState({ labelEstado: 'Guardado', grid_valores_recibidos: this.props.Val_recibidos, total_recibidos: Math.round(this.props.Total_recibido * 100) / 100,
                        total_retencion: Math.round(this.props.Total_ret * 100)/100, c_total_recibo: this.props.total_recibo, grid_valores_aplicados: this.props.Val_aplicados,
                        total_aplicacion: Math.round(this.props.Total_aplicados * 100)/100, grid_docs_pendientes: this.props.Val_libroDiario,
                        grid_distribucionpago: this.props.Val_Distribuido, total_DISPG: Math.round(this.props.Total_dist * 100) / 100,
                        grid_notas_credito: this.props.Val_NotasCredito, total_ntacredito: this.props.Total_NC, recaudador_sel: this.props.recaudador,
                        cliente_sel: this.props.cliente, vendedor_sel: this.props.vendedor, fechaRecibo: moment(this.props.fecha_recibo, 'DD/MM/YYYY'),
                        observacion_vendedor: this.props.observacion_vendedor?this.props.observacion_vendedor:'',
                        }, ()=>{
                        this.clear_ActionButtons();
                        this.controlerroresCarga();

                        //BLOCK GRID VR
                        this.lockGridVR();
                        }
                    )                   
                    
                }else if(this.props.recibo_estado==='B'){
                    alert("El recibo esta bloqueado, cuenta bancaria no registrada.")
                    this.clear_ActionButtons();
                }else if(this.props.recibo_estado==='A'){
                    alert("Recibo anulado");
                    this.clear_ActionButtons();
                }else if(this.props.recibo_estado==='X'){                    
                    alert(this.props.mensaje);
                    this.clear_ActionButtons();
                }

                if((this.props.Val_Distribuido===undefined?0:this.props.Val_Distribuido.length) <= 0){
                    this.setState({boton_distribuir: false, boton_aplicar_distribucion: false});
                }
                //console.log('CLIENTE: ', this.props.cliente)
                this.controlRetenciones(this.props.cliente);

                //Validacion por Cierre de cartera
                validarFechaCierreCartera(this.state.empresa, this.props.fecha_recibo , fechaProceso).then((valid)=>{
                    //console.log('FECHA CIERRE: ', valid)
                    if(valid.value===false){        
                        alert(valid.msg);
                        this.setState({ recaudador: true });
                    }
                })
            })
            .catch(()=>{ 
                //alert(error);    
            })
        }
    }

    controlRetenciones(cliente){
        var impuesto = {}; 
        this.cargarObjetos('/clientes/'+cliente.value).then((cli)=>{
            if(cli.tipo_persona===null || cli.ContbEspecial===null){
                alert("- El cliente no posee el campo tipo persona o contribuyente ESP, modifiquelo antes de continuar")
                this.changePermisosButtons(true, true, true)
            }else{
                console.log("PARAMTROS IMPRET: ", this.state.parametrosImpRetIvaCli)
                //SELECCION DE IMPUESTO
                if(this.state.parametrosImpRetIvaCli.length > 0){
                    console.log("CLIENTE: ", cli)
                    switch (cli.tipo_persona){
                        case 'N':
                            if(cli.ContbEspecial==='S'){
                                impuesto.bienes = this.serchImpRetIva('BPJ', 'CES');
                                impuesto.servicio = this.serchImpRetIva('SPJ', 'CES');
                            }else{
                                impuesto.bienes = this.serchImpRetIva('BPN', 'PN');
                                impuesto.servicio = this.serchImpRetIva('SPN', 'PN');
                            }
                            break;
                        case 'J':
                            if(cli.ContbEspecial==='S'){
                                impuesto.bienes = this.serchImpRetIva('BPJ', 'CES');
                                impuesto.servicio = this.serchImpRetIva('SPJ', 'CES');
                            }else{
                                impuesto.bienes = this.serchImpRetIva('BPJ', 'PJ');
                                impuesto.servicio = this.serchImpRetIva('SPJ', 'PJ');
                            }
                            break;
                    
                        default:
                            break;
                    }

                    this.setState({retIvaCliSel: Object.keys(impuesto).length===0?null:impuesto});
                }
            }
        })
    }

    //Busca en el state parametrosImpRetIvaCli el IMP INDICADO y lo retorna
    serchImpRetIva(tipo, tipoPersona){
        var result = null
        this.state.parametrosImpRetIvaCli.forEach((IMP)=>{
            if(IMP.Tipo === tipo && IMP.TipoPersona === tipoPersona){
                result = IMP.Porcentaje;
            }
        })

        return result
    }

    controlerroresCarga(){
        if(this.state.grid_distribucionpago.length <= 0){
            alert('El recibo consulta no se encuentra en la tabla ReciboDistribucion');
        }

        if(this.state.grid_docs_pendientes.length <=0){
            alert('El recibo consulta no se encuentra en la tabla CabReciboDistribucion');
        }

        // if(this.props.exist_auditoria === false){
        //     alert('El recibo consulta no se encuentra en la tabla Auditoria_Cobranza_Movil');
        // }
    }

    lockGridVR(){
        
        this.changeStateHeader('retFteBienes', false);
        this.changeStateHeader('retFteServicio', false);
        this.changeStateHeader('retIvaBienes', false);
        this.changeStateHeader('retIvaServicio', false);
    }

    unlockGridVR(){
        
        this.changeStateHeader('retFteBienes', true);
        this.changeStateHeader('retFteServicio', true);
        this.changeStateHeader('retIvaBienes', true);
        this.changeStateHeader('retIvaServicio', true);
    }

    changeRecibo(event){

        //setea valor nuevo recibo
        const target = event.target;    
        const value = target.value;
        this.setState({recibo: value});

    }

    docPendientesSinRetencion(VA){

        var arrayResult = [];
        var accAplicar = 0.00;
        var accRet = 0.00;
        var accSaldo = 0.00;

        for(var index = 0; index < VA.length; index++){
            
            if(VA[index].saldo > 0){
                console.log('index: ', index)
                var item = {}
                item.Tipo_Transaccion = VA[index].Tipo_Transaccion;
                item.Movimiento = VA[index].Movimiento;
                item.fecha = VA[index].fecha_documento;
                item.valor = parseFloat(VA[index].valor_original);
                item.saldo = parseFloat(VA[index].saldo);
    
                //ACC SALDO
                accSaldo = accSaldo + VA[index].saldo;
                let valor = parseFloat(VA[index].valor);
                //item.val_aplicar = parseFloat(VA[index].valor);
                console.log('AUTO DP item.valor: ',valor, 'item.saldo: ',item.saldo, 'COMP: ',item.valor > item.saldo  )
                item.val_aplicar =  valor > item.saldo?Math.round(item.saldo*100)/100:Math.round(valor*100)/100;
                
                //ACC Total aplicados
                accAplicar = accAplicar + item.val_aplicar; 
                
                item.Vendedor = VA[index].Vendedor;
                arrayResult.push(item);
            }
        }//END FOR

        var auxacc_ap = 0.00;
        auxacc_ap = Math.round(accAplicar * 100) / 100;
        this.setLabelTotal_aplicados(auxacc_ap , accRet, Math.round(accSaldo * 100) / 100);

        return arrayResult
    }
    
    //Grid API => VR
    onGridReady(params) {
        this.api = params.api;
        this.columnApi = params.columnApi;
    }

    //Grid API => DP
    onGridReadyDP(params) {
        this.apiDP = params.api;
        this.columnApiDP = params.columnApi;
    }

    componentDidMount() {
        
        Promise.all([
            cargarCatalogos('Banco'),
            this.cargarCatalogosOtrosSaveCat('CAJA-RETIVACLI','parametrosImpRetIvaCli'),
            cargarCatalogos_Otros('COM-TIPOPROVEDOR'),
            this.cargarCatalogosOtrosCatchResult('COM-IMPALL','catalogoImpuestos'),
            this.cargarCatalogosOtrosSaveCat('CAJA-IMPRET','parametrosImpRetencion'),
            /*cargarCatalogosGenerico('/vendedores') cargarCatalogosGenerico('/recaudadores'), cargarCatalogosGenerico('/clientes'), cargarCatalogosGenerico('/vendedores'),*/
            this.getParametrosCobranza(), cargarParametros("COBRANZA&cadena_busq_cobranza=CHE", 'tabla'), cargarCatalogos_Otros('DIASRETRODOC'),  this.props.generar_LogAuditoriaIngresoForm('0501'),
        ])
        .then(([result_banco ,result_ivaretcli ,result_tipoRetencion, result_IMPRET, resul_paramsImpRet/*, result_recaudadores, result_clientes, result_vendedores*/, result_cobranza, result_cheq, result_param]) => {
            let empresa = JSON.parse(getItemDatosSesion('empresaActual')).Id;
            let fechaProceso = getFechaProcesoPorModulo('05');

            var arrayCatalogoTipoRet = [];
            if(result_tipoRetencion.length > 0){
                result_tipoRetencion.forEach((TIPO)=>{
                    if(TIPO.value==='B' || TIPO.value==='S'){
                        var item = {};
                        item.value = TIPO.value;
                        item.label = TIPO.label;
                        arrayCatalogoTipoRet.push(item);
                    }
                })
            }
            
            this.setState({ catBancos: result_banco,parametrosImpRetIvaCli :result_ivaretcli,  
                tipoRetencion: arrayCatalogoTipoRet, catalogoImpuestos :result_IMPRET, 
                parametrosImpRetencion :resul_paramsImpRet, /*c_recaudador: result_recaudadores,  
                c_clientes: result_clientes, c_vendedores: result_vendedores,*/
                parametros_ret: result_cobranza, parametros_che: result_cheq, paramDiasRetroDoc: result_param[0] ,empresa: empresa,
                readOnly: this.props.permiteCambioFProceso==='S'?false:true,
                fechaCaja: moment(fechaProceso,'DD/MM/YYYY')
            })             
            
            this.props.change('fecha_caja', fechaProceso)
        })
        .catch(err => {
          console.log(err);
          alert("Error al cargar parametros de inicio, no se puede continuar");
          this.changePermisosButtons(true, true, true)
        });
        
        this.props.cargar_ValoresIniciales();
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0501');
    }

    logIn(){
        let errors = ''
        var data = {};
        data = { user: this.state.userInput, pass: this.state.passInput,
            codForm: this.props.formulario}
        if(this.state.userInput.length >0 && this.state.passInput.length >0){
            if(this.state.recibo!=='' || this.props.cliente!==null){
                
                //Proceso Adquirir clave
                Promise.all([this.authOperation(data)])
                .then(([result_auth])=>{
    
                    if(result_auth === true){
                        this.setState({super: true})                            
                        
                        
                        let config_request = {
                            method: 'GET',
                            url: 'caja/cobranza/'+this.state.recibo+'/facturaspendientes/cliente/'+this.props.cliente.value,
                        }
                        global_axios(config_request)
                        .then((response)=>{
                            if(response.data.length > 0){

                                let arrayDPCliente = response.data;

                                arrayDPCliente.forEach((DPC)=>{
                                    DPC.Login = 1;
                                })

                                this.setState({docs_porPeticion: []},()=>{
                                    this.setState({docs_porPeticion: arrayDPCliente})
                                })
                                
                                let porPeticion = arrayDPCliente;
                                console.log("DOCS POR PETICION: ", arrayDPCliente)
                                
                                //Agregación de filas consultadas
                                porPeticion.forEach((DOCS)=>{
                                    //Validacion para no agregar documentos existentes
                                    this.state.grid_docs_pendientes.forEach((DP)=>{
                                    
                                    })
                                    this.setState({ grid_docs_pendientes: this.immutablePush(this.state.grid_docs_pendientes, DOCS) })
                                })                                
                            }else{
                                errors+='- El cliente no tiene documentos pendientes.\n'
                            }

                            /* PROCESO DE SUPER USER POR DEFECTO */
                            //Clear Distribuidos
                            this.setState({ grid_distribucionpago: []})
                            this.setState({ total_DISPG: 0.00 });

                            //Cambio de permisos en el grid
                            this.changeStateHeader('Vencimiento_cheq', true);
                            this.changeStateHeader('ValorRecaudado', true);
                            this.changeStateHeader('Cuenta', true);
                            this.changeStateHeader('Cheque', true);

                            if(this.state.observacion_supervisor==="" || this.state.observacion_supervisor===undefined){
                                errors+="- Ingrese observación por el cambio\n";
                            }

                            var saldo
                            saldo = this.SumValoresGrid(this.state.grid_docs_pendientes, 'saldo');                            
                            this.setState({total_saldo_recibido_DP: saldo});

                            this.setState({usuario_aprobador: this.state.userInput})

                            this.clearAuth();

                            alert(errors);
                        })
                        .catch(err => {
                            console.log(err);
                        });                        
                    }else{
                        alert("Acceso denegado");
                        this.clearAuth();
                    }
                })
                .catch((error)=>{
                    this.clearAuth();
                    alert(error.response?error.response.data.msg:error.message);  
                });        
            }else{
                alert("Antes de pedir autorizacion carge un recibo")
            }

        }else{
            alert("Llenar los campos requeridos para solicitar autentificación")
        }
    }

    immutablePush(array, newItem){
        return [ ...array, newItem ];  
    }

    authOperation(data){
        //Proceso Adquirir clave
        let config_request = {
            method: 'POST',
            url: '/validate/',
            data
        }

        return new Promise((resolve, reject) => {
            global_axios(config_request)
                .then((response)=>{
                    resolve(response.data);
                })
                .catch((error)=>{
                    reject(error);   
                })
            })
    }

    changeUser(event){

        event.preventDefault();
        const target = event.target;    
        const value = target.value;
        this.setState({userInput: value});
    }

    changePass(event){
        
        const target = event.target;    
        const value = target.value;
        this.setState({passInput: value});
    }

    clearAuth(){
        this.setState({userInput: '', passInput: ''});
    }

    clearEstados(){
        this.setState({ super: false, cheq_alert: false, exist_chq_protestados: false, Error_distribucion_recibida: false,
                        recibo_estado: 'P', operacion_incompleta: false, efectivo_alert: false});
    }

    changeStateHeader(col_field, value){
        var col = this.columnApi.getColumn(col_field);
        var colDef = col.getColDef();
        colDef.editable = value;
        this.api.refreshHeader();
    }

    /*
    array => a enviar
    column => columna a sumar 
    */
    SumValoresGrid(array, column){
        var acc_suma = 0.00;
        array.forEach((array)=>{
            if(array.hasOwnProperty(column)){
                if( !(isNaN(parseFloat(array[column])))){
                    acc_suma = acc_suma + parseFloat(array[column]);
                }
            }
        })
        
        return Math.round(acc_suma * 100) / 100;
    }

    aplicarDistribuirGeneral(){
        var VR_recibido = Math.round(parseFloat(this.state.total_recibidos)*100)/100;
        var DP_val_aplicar = Math.round(parseFloat(this.state.total_aplicado_DP)*100)/100;
        var totalRetVR = Math.round(parseFloat(this.state.total_retencion)*100)/100;
        var totalRetDP = Math.round(parseFloat(this.state.total_ret_DP)*100)/100;
        var diferencia = 0;
        var difRet = 0;
        console.log('VR RECIBIDO: ', VR_recibido, 'DP_VALAPLICAR: ', DP_val_aplicar)
        diferencia =  Math.round((VR_recibido - DP_val_aplicar)*100)/100;
        difRet = Math.round((totalRetVR - totalRetDP)*100)/100;
        console.log('DIF: ', diferencia, difRet)
        if(VR_recibido === DP_val_aplicar && totalRetVR === totalRetDP){
            // PREGUNTA POR SI SOLO EXISTEN CHEQUES
            //console.log('RET: ', this.props.ret_exist, 'EFECTIVO/DPT: ', this.props.cash_dpto_exist)
            //if(this.props.ret_exist === false && this.props.cash_dpto_exist=== false){
                //this.setValoresDistribuidosOnlyChques(this.state.grid_valores_recibidos);
                //this.validacionDistribucion();
            //}else{
                // EJECUTA DISTRIBUCION GENERAL
                this.distribuirDocsPendientesRET(1);
            //}                        
        }else{
            console.log('ENTRO A NC CREATION')
            if(diferencia > 0){
                this.setState({diferenciaVA: diferencia},()=>{
                    this.completarConNotaCredito();
                })
            }
            alert("Existen una diferencia de "+diferencia+" entre el valor recibido y el total aplicado, diferencia retenciones: "+difRet);
        }        
    }

    validacionSobrepagoDentroDP(){
        let ultimoRecursoNFC = false;
        let docsTraidos = this.state.docs_porPeticion;
        let contadorOK = 0;

        this.state.grid_docs_pendientes.forEach((DP)=>{
            if(DP.hasOwnProperty('Login') === true){
                console.log('Comparacion VALS: VALOR:', DP.valor , 'APLICADO: ', DP.val_aplicar)
                if(DP.valor === DP.val_aplicar){
                    contadorOK++;
                }
            }
        })
        console.log('COMP: ', contadorOK === docsTraidos.length , contadorOK, docsTraidos.length)
        if(contadorOK === docsTraidos.length){
            ultimoRecursoNFC = true;
        }

        return ultimoRecursoNFC;
    }

    getId_Doc(movimiento){
        var ID = null;
        //OBTENER ID POR CASO SIN DOCS PENDIENTES CARGADOS
        if(this.state.usuario_aprobador===""){
            ID = this.getDocumentosDistribuidos(movimiento);
        //OBTENER ID POR CASO CON DOCS PENDIENTES
        }else{
            ID = this.getDocumentosPorPeticion(movimiento);
            if(ID===null){
                ID = this.getDocumentosDistribuidos(movimiento);
            }
        }
        return ID;
    }

    //Busca el doc en grid_valores_aplicados
    getDocumentosDistribuidos(movimiento){
        var ID = null;
        this.state.grid_valores_aplicados.forEach((APL)=>{
 
            if(movimiento === APL.Movimiento){
                ID = APL.Id_Doc
            }
        })
        return ID;
    }

    //Busca el doc en docs_porPeticion
    getDocumentosPorPeticion(movimiento){
        var ID = null;
        this.state.docs_porPeticion.forEach((DP)=>{
            if(movimiento === DP.Movimiento){
                ID = DP.IdDoc
            }
        })
        return ID;
    }

    //Botones
    AplicarRecaudador(){
        var arrayVR = [];
        var arrayDistribucion = [];
        var selected = false;

        let fechaProceso = getFechaProcesoPorModulo('05');

        let transaccion = window.confirm('¿Grabar la cobranza?');
        if(transaccion){
            selected = true
            if(this.state.exist_chq_protestados===true){
                let continuar = window.confirm('¿Se encontrarón documentos protestados está seguro de continuar con la operación?');
                if (continuar){
                    selected = true;  
                }else{
                    selected = false;
                }
            }
            if(this.state.super === true && (this.state.observacion_supervisor === undefined || this.state.observacion_supervisor === "")){
                alert("Ingrese la observación de supervisor antes de guardar");
                selected = false;
            }
            if(this.state.grid_distribucionpago.length <= 0){
                alert("Aplique la distribucion antes de guardar");
                selected = false;
            }
            if(this.state.cheq_alert === true){
                alert("Cheque ya ingresado verificar con sistemas");
                selected = false;
            }
            // Validacion de fecha de proceso que se puede cambiar ------------------------------
            if (this.props.permiteCambioFProceso==='S'){
                let resultadoValidFProceso = validarFechaTransaccionSeleccionada(this.state.fechaCaja, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
                console.log('PARAMETRO FECHA PROCESO: ', resultadoValidFProceso)
                if(resultadoValidFProceso.esValida===false){
                    selected = false;
                    alert(resultadoValidFProceso.msg)
                }
            }

            if(this.state.efectivo_alert===true){
                let error = this.verificadorVRParaEfectivos(this.state.grid_valores_recibidos)
                console.log('VERIFICACION DE EFECTIVO: ', error)
                if(error!==''){                   
                    selected = false;
                    alert(error)
                }
            }

            console.log('DIFERENCIA EN SALDOS: ', parseFloat(this.state.c_total_recibo,10) === parseFloat(this.state.total_DISPG,10), this.state.c_total_recibo, this.state.total_DISPG)
            if(parseFloat(this.state.c_total_recibo.toFixed(2),10) !== parseFloat(this.state.total_DISPG.toFixed(2),10)){
                selected = false;
                alert('- Existen diferencias entre el total recibido y total distribución')
            }

            //Validacion por Cierre de cartera
            validarFechaCierreCartera(this.state.empresa, formatearFechaMoment_a_String(this.state.fechaCaja) , fechaProceso).then((valid)=>{
                console.log('FECHA CIERRE: ', valid)
                if(valid.value===false){        
                    selected = false;
                    alert(valid.msg);
                }

                //Continuacion de proceso segun validacion
                if(selected === true ){            
                    var data ={};
                    
                    this.state.grid_valores_recibidos.forEach((VR)=>{
                        var item = {};
                        item.Localidad = '01';
                        item.NRecibo = parseInt(this.state.recibo, 10);
                        item.SecuencialValRecibido = VR.secuencia;
                        item.FormaPago = VR.Forma_Pago;
                        item.Banco = VR.Banco_num;
                        item.BancoDescripcion = VR.Banco;
                        item.Cuenta = VR.Cuenta;
                        item.NDocumento = VR.Cheque;
                        item.Emisor = VR.Emisor;

                        if(parseInt(VR.Forma_Pago, 10)===3 || parseInt(VR.Forma_Pago, 10)===8 || parseInt(VR.Forma_Pago, 10)===4 || parseInt(VR.Forma_Pago, 10)===5){
                            item.FechaVencimiento = VR.FechaDeposito;
                        }else{
                            item.FechaVencimiento = VR.Vencimiento_cheq;
                        }

                        item.Valor = parseFloat(VR.ValorRecaudado,10);
                        item.NFacturaRetencion = (VR.hasOwnProperty('fac_ret')?VR.fac_ret:null);
                        item.RtfBienes = parseFloat(VR.retFteBienes, 10);
                        item.RtfServicio =   parseFloat(VR.retFteServicio,10);
                        item.RIvaBienes = parseFloat(VR.retIvaBienes,10);
                        item.RIvaServicio = parseFloat(VR.retIvaServicio,10);
        
                        arrayVR.push(item);
                    })
        
                    this.state.grid_distribucionpago.forEach((DISP)=>{
                        var item = {};
                        item.Localidad = '01';
                        item.NRecibo = parseInt(this.state.recibo, 10);
                        item.Secuencial = parseInt(DISP.secuencia,10);
                        item.SecuencialValRecibido = parseInt(DISP.sec_VR,10);
                        item.TipoDocumento = DISP.tipo_doc;
                        item.NumeroDocumento = DISP.num_doc;
                        item.ValorAplicado = parseFloat(DISP.valor,10);
                        if(DISP.tipo_doc==='FAC'){
                            item.IdDoc = this.getId_Doc(DISP.num_doc,10);
                        }
                        arrayDistribucion.push(item);
                    })
        
                    data.ValoresRecibidos = arrayVR;
                    data.DistribucionPago = arrayDistribucion;
                    data.fechaCaja = formatearFechaMoment_a_String(this.state.fechaCaja);
                    data.recibo = this.state.recibo;
        
                    data.usuario_aprobador = this.state.usuario_aprobador;
                    data.observacion_supervisor = this.state.observacion_supervisor?this.state.observacion_supervisor.toString().toUpperCase():this.state.observacion_supervisor;
                    
                    //Adicion de grid de Auditoria por cambios en los bancos de Valores Recibidos
                    data.bancosChanges = this.state.changesVR.length===0?null:this.state.changesVR;
        
                    //Campos moneda
                    let errorSesion = null;
                    try{
                        data.moneda = JSON.parse(getItemDatosSesion('moneda')).Moneda;
                        data.dolar = JSON.parse(getItemDatosSesion('moneda')).Cotizacion;
                        data.user = getItemDatosSesion('usuario').toString(); 
                    }catch(error){
                        errorSesion = 1;
                        alert('Actualice su navegador')
                    }
        
                    if(errorSesion===null){
                        let config_request = {
                            method: 'POST',
                            url: 'caja/cobranza/',
                            data
                        }
                        this.props.cambiar_VisualizacionLoading(true);
                        global_axios(config_request)
                        .then((response)=>{
                            this.props.cambiar_VisualizacionLoading(false);
                            alert(response.data.msg)
                            this.limpiarPantalla('B');                            
                        })
                        .catch((error) => {
                            this.props.cambiar_VisualizacionLoading(false);
                            alert(error.response?error.response.data.msg:error.message);  
                        });
                    }
                }
            })
        }
    }

    verificadorVRParaEfectivos(array){
        let errores = ''
        array.forEach((VR)=>{
            if(parseInt(VR.Forma_Pago,10)===3 || parseInt(VR.Forma_Pago,10)===8){
                console.log('ERRORES DE EFECTIVO')
                console.log('DOC: ', VR.Cheque)
                console.log('FEC. VEN: ', VR.FechaDeposito)
                if(VR.Cheque==='' || VR.FechaDeposito===''){
                    errores+=`- Ingrese número de documento o fecha de depósito de la forma de pago ${VR.secuencia}\n`
                }
            }
        })

        return errores
    }

    Limpiar(){
        this.props.reset();
        this.props.cargar_ValoresIniciales();
        this.setState({
            //Grids
            grid_valores_recibidos: [],
            grid_valores_aplicados: [],
            grid_docs_pendientes: [],
            grid_distribucionpago: [],
            grid_notas_credito:[],

            //Valores
            total_recibidos: 0.00,
            total_retencion: 0.00,
            total_aplicacion: 0.00,
            total_ntacredito: 0.00,
            total_DISPG: 0.00,

            //Estados
            Error_distribucion_recibida: false,
            recaudador: false,
            cartera: false,
            cobro: false,

            super: false,
            cheq_alert: false,
            exist_chq_protestados: false,
            sobre_pago: false,
            recibo_estado: 'P',
            operacion_incompleta: false,

            //Botones distribucion
            boton_distribuir: false,
            boton_aplicar_distribucion: true,
        
            //Docs Pendientes
            doc_pendientes: [],
            cheques_usados: [],
            docs_porPeticion: [],            
            total_aplicado_DP: 0.00,

            //Usuario
            userInput: "",
            passInput: "",
            usuario_aprobador: '',
        
            //Recibo
            recibo: '',

            //Cabecera
            observacion_vendedor: '',
            observacion_supervisor: '',
            recaudador_sel: null,
            cliente_sel: null,
            vendedor_sel: null,
            })
    }

    limpiarPantalla(opcion){
        //Cabecera
        this.props.reset();
        this.props.cargar_ValoresIniciales();

        //Cabecera
        let fechaProceso = getFechaProcesoPorModulo('05');
        this.setState({ grid_valores_recibidos: [], total_recibidos: 0.00, total_retencion: 0.00 ,c_total_recibo: 0.00,
            grid_valores_aplicados: [], grid_docs_pendientes: [],total_aplicacion: 0.00 , diferenciaVA: 0.00,
            total_retencion_fact_traidas: 0, total_saldo_recibido_DP: 0.00, total_aplicado_DP: 0.00, total_ret_DP: 0.00, grid_distribucionpago: [],
            total_DISPG: 0.00, doc_pendientes: [], changesVR: [], docs_porPeticion: [], usuario_aprobador: '', labelEstado: '',
            recaudador_sel: null, cliente_sel: null, vendedor_sel: null, fechaRecibo: null, observacion_vendedor:'', observacion_supervisor:''
            ,fechaCaja: moment(fechaProceso,'DD/MM/YYYY')
        })

        this.clear_ActionButtons();

        //Desactiva botones
        this.desactivarDistribuidos();

        //Limpia super
        this.clearAuth();

        //Limpia estados
        this.clearEstados();

        //Desbloqueo GRID VR INGRESO VALORES
        this.unlockGridVR();

        //BLOQUEO DE CAMBIOS POR AUTORIZACION
        this.changeStateHeader('Vencimiento_cheq', false);
        this.changeStateHeader('ValorRecaudado', false);
        this.changeStateHeader('Cuenta', false);
        this.changeStateHeader('Cheque', false);


        if(opcion==='A'){
            this.setState({recibo: ''});
        }
    }

    //Reporte
    impCarteraCliente(){
        let fechaProceso = getFechaProcesoPorModulo('05')

        if(this.props.cliente){
            let fechaFormat = formatearFechaMoment_a_StringFormatoReporte(moment(fechaProceso, 'DD/MM/YYYY'));
            visualizarReporteEnPdf('&rpt=11&param1='+fechaFormat+'&param2='+this.props.cliente.value+'&param6=C')
        }
    }

    //Adicion por REQ TIPO DE RETENCIONES
    cargarObjetos(ruta){
        return new Promise((resolve, reject) => {
            global_axios.get(ruta)
            .then((response)=>{
                resolve(response.data)
            })
            .catch((err)=>{
                reject(err);
            });
        });
    }

    modificarValoresRecibidos(){
        let fila = this.api.getSelectedRows()[0];
        if(fila){
            //Adicion para deposito cuenta & Transferencias
            if(parseInt(fila.Forma_Pago,10)===1 || parseInt(fila.Forma_Pago,10)===2 || parseInt(fila.Forma_Pago,10)===6 || parseInt(fila.Forma_Pago,10)===4 || parseInt(fila.Forma_Pago,10)===5){
                this.setState({editarValoresRecibidos: !this.state.editarValoresRecibidos, catBancosRow_sel: null}, ()=>{
                    this.setState({catBancosRow_sel: fila.Banco_num})
                })
            }else{
                alert('Edición solo activa para bancos')
            }
        }else{
            alert("Seleccione una fila a editar")
        }
    }

    cambiarBancosPorFila(){
        var errors = '';
        var proceder = true;

        if(this.state.catBancos_sel === this.state.catBancosRow_sel && this.state.catBancos_sel!==null){
            errors+=' - No hay cambios a registrar';
            proceder = false;
        }

        if(proceder===true){            
            let fila = this.api.getSelectedRows()[0];
            //Manipulacion e insert de cambios
            this.insertUpdateArrayCambios(fila);
            
            //Actualizacion en el grid Valores Recibidos
            this.state.grid_valores_recibidos.forEach((VR)=>{                
                if(VR.recibo === fila.recibo && VR.secuencia === fila.secuencia){
                    VR.Banco_num = this.state.catBancos_sel.value;
                    VR.Banco = formatearLabel(this.state.catBancos_sel.label);
                }
            })

            this.api.refreshCells();
            this.setState({editarValoresRecibidos: false, catBancos_sel: null })
        }else{
            alert(errors)
        }
    }

    insertUpdateArrayCambios(fila){
        let find = false;
        
        this.state.changesVR.forEach((BAN)=>{
            if(BAN.Recibo === fila.recibo && BAN.Secuencia === fila.secuencia){
                find = true;
                BAN.BancoCambio = this.state.catBancos_sel.value;
                if(BAN.BancoOriginal===""){
                    BAN.BancoOriginal = fila.Banco_num;
                }
            }
        })

        if(find===false){
            let item = {};
            let array = this.state.changesVR;
            item.AuditoriaId = ''
            item.Recibo = fila.recibo;
            item.Secuencia = fila.secuencia;
            item.Usuario = this.props.usuario;
            item.CuentaOriginal = fila.Cuenta;
            item.CuentaCambio = ''; 
            item.ChequeOriginal = fila.Cheque; 
            item.ChequeCambio = '';
            item.BancoOriginal = fila.Banco_num;
            item.BancoCambio = this.state.catBancos_sel.value;
            item.FechaVenOriginal = fila.Vencimiento_cheq;
            item.FechaVenCambio = '';
            item.UsuarioAprobador = this.state.usuario_aprobador?this.state.usuario_aprobador:'';
            item.FechaSistema = '';
            item.Terminal = '';
            item.FormaPagoOriginal = fila.Forma_Pago;
            item.Cliente = this.props.cliente.value;

            array.push(item)
            this.setState({changesVR: array})
        }
    }

    //AprobacionChanges para cambios con auth
    insertUpdateArrayCambiosAuth(fila, name, oName, oldValue, col){
        let find = false;
        console.log('FILA: ', fila)
        //Existente
        this.state.changesVR.forEach((CHA, i)=>{
            if(CHA.Recibo === fila.recibo && CHA.Secuencia === fila.secuencia){
                if(CHA[name] !== fila[col]){
                    find = true;
                    CHA[name] = fila[col];
                    CHA.UsuarioAprobador = this.state.usuario_aprobador;
                    if(CHA[oName]===""){
                        CHA[oName] = oldValue;                        
                    }
                }else if(CHA[name] === fila[col]){
                    find = true;
                }
            }
        })

        if(find===false){
            let item = {};
            let array = this.state.changesVR;
            item.AuditoriaId = ''
            item.Recibo = fila.recibo;
            item.Secuencia = fila.secuencia;
            item.Usuario = this.props.usuario;
            
            if(col==='Cuenta'){
                item.CuentaOriginal = oldValue;
                item.CuentaCambio = fila[col]; 
            }else{
                item.CuentaOriginal = fila.Cuenta;
                item.CuentaCambio = ''; 
            }

            if(col==='Cheque'){
                item.ChequeOriginal = oldValue; 
                item.ChequeCambio = fila[col];
            }else{
                item.ChequeOriginal = fila.Cheque; 
                item.ChequeCambio = '';
            }
            
            if(col==='Vencimiento_cheq'){
                item.FechaVenOriginal = oldValue;
                item.FechaVenCambio = fila[col]
            }else{
                item.FechaVenOriginal = fila.Vencimiento_cheq;
                item.FechaVenCambio = '';
            }
            
            item.BancoOriginal = fila.Banco_num;
            item.BancoCambio = '';
            item.UsuarioAprobador = this.state.usuario_aprobador;
            item.FechaSistema = ''
            item.Terminal = ''
            item.FormaPagoOriginal = fila.Forma_Pago;
            item.Cliente = this.props.cliente.value;

            array.push(item)
            console.log('ARRAY CAMBIOS: ', array)
            this.setState({changesVR: array})
        }
    }

    //27/11/2018
    completarConNotaCredito(){
        let fechaProceso = getFechaProcesoPorModulo('05')

        if(this.state.grid_docs_pendientes.length > 0 ){
            let msg = window.confirm('Diferencia en recibo detectada, ¿Se añadirá una NC por el excedente del recibo? ');

            if(msg){
                let item = {};

                item.Movimiento=""
                item.Tipo_Transaccion="NC"
                item.Vendedor=""
                item.fecha=  moment(fechaProceso, 'DD/MM/YYYY').format()
                item.retencion=0
                item.saldo= Math.round(parseFloat(this.state.diferenciaVA, 10)*100)/100;
                item.val_aplicar= Math.round(parseFloat(this.state.diferenciaVA, 10)*100)/100;
                item.valor=Math.round(parseFloat(this.state.diferenciaVA, 10)*100)/100;
                

                let valid = true;
                this.state.grid_docs_pendientes.forEach((DATA)=>{
                    if(DATA.Tipo_Transaccion === 'NC'){
                        valid = false;
                    }
                })
                
                if(valid===true){
                    this.setState({ grid_docs_pendientes: this.immutablePush(this.state.grid_docs_pendientes, item) }, ()=>{
                    
                        let valAplicado = this.SumValoresGrid(this.state.grid_docs_pendientes, 'val_aplicar'); 
                        this.setState({total_aplicado_DP: Math.round(valAplicado*100)/100,
                        diferenciaVA: 0});
                    })
                }else{
                    alert("- Solo se puede generar una NC por el total de la diferencia del recibo")
                }
            }
        }else{
            alert('Distribuya los valores recibidos antes de usar esta función')
        }
    }

    render(){
        const invisible = {display: 'none'};
        const visible = {display: 'block'};        
        return(
            <ContenedorForm porc_ancho={95}>
            <HeaderForm>
                <TituloForm>Cobranza</TituloForm>
                <LabelCabecera>{this.state.labelEstado}</LabelCabecera>
            </HeaderForm>
                <CuerpoForm>
                    <ContainerEdit margen_abajo='4' alto='43'>
                        <Row>
                            <ContainerCol className='col-md-1'>
                                <LabelForm>Recibo:</LabelForm>
                            </ContainerCol>  
                            <ContainerCol className='col-md-2'>
                                <InputSearch tipoInput='text' nombre='recibo' placeholder='Movimiento' valor={this.state.recibo} func_CambiarValor={this.changeRecibo} 
                                func_BuscarValor={this.getCobranza} /*func_OnFocus={()=>{this.limpiarPantalla('A')}}*/ maxLength='10'/> 
                            </ContainerCol> 
                            {/* <div style={((this.state.grid_docs_pendientes.length > 0 || this.state.sobre_pago === true || this.state.operacion_incompleta === true) && this.state.recibo_estado==='P')?visible:invisible}> */}
                                <ContainerCol className='col-md-1 col-md-offset-4'>
                                    <LabelForm>Usuario:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-md-1'>                                
                                    <InputText name='usuario' type="text" value={this.state.userInput}  className='form-control input-sm' placeholder='user' onChange={this.changeUser}/>
                                </ContainerCol>

                                <ContainerCol className='col-md-1'>
                                    <LabelForm>Contraseña:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-md-1 '>
                                    <InputText name='password'  type="password" value={this.state.passInput} className='form-control input-sm' onChange={this.changePass}/>
                                </ContainerCol>

                                <ContainerCol className='col-md-1 '>
                                    <button type="button" className='btn btn-default medida-button-busq-especif' onClick={this.logIn}><i className="fa fa-key"></i> Aceptar</button>
                                </ContainerCol>
                            {/* </div> */}
                        </Row>             
                    </ContainerEdit>
                    <Row>
                        <div className='col-md-3'>
                            <LabelForm>Recaudador:</LabelForm>
                            <ReactSelectAsync value={this.state.recaudador_sel} disabled={true} func_loadOptions={this.getOptions_Clientes} func_onChange={(value)=>{if(Array.isArray(value)){value=null};this.setState({recaudador_sel: value?value:null});}}/>
                            
                        </div>     
                        <div className='col-md-3'>
                            <LabelForm>Cliente:</LabelForm>
                            <ReactSelectAsync value={this.state.cliente_sel} disabled={true} func_loadOptions={this.getOptions_Clientes} func_onChange={(value)=>{if(Array.isArray(value)){value=null};this.setState({cliente_sel: value?value:null});}}/>
                        </div>
                        <div className='col-md-2'>
                            <LabelForm>Vendedor:</LabelForm>
                            <ReactSelectAsync value={this.state.vendedor_sel} disabled={true} func_loadOptions={this.getOptions_Clientes} func_onChange={(value)=>{if(Array.isArray(value)){value=null};this.setState({vendedor_sel: value?value:null});}}/>
                        </div>
                        <div className='col-md-2'>
                            <LabelForm >Fecha caja:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaCaja}
                                disabled={this.state.readOnly} func_onChange={(fecha)=>{this.setState({fechaCaja: fecha})}}/>
                        </div>              
                        <div className='col-md-2 '>
                            <LabelForm >Fecha recibo:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaRecibo}
                                disabled={true} func_onChange={(fecha)=>{this.setState({fechaRecibo: fecha})}}/>
                        </div>                       
                    </Row>
                    <Row>
                        <div className='col-md-6'>
                            <LabelForm >Observación vendedor:</LabelForm>
                            <InputText name="observacion_vendedor" value={this.state.observacion_vendedor} disabled={true}/>
                        </div>
                        <div className='col-md-6'>
                            <LabelForm >Observación Supervisor:</LabelForm>
                            <InputText mayusculas='yes' name="observacion_supervisor" value={this.state.observacion_supervisor} disabled={this.state.super===true?false:true} onChange={this.actualizarCampos}/>                               
                        </div>
                    </Row>                    
                    <Row>
                        <ContenedorGrid className='col-md-9' ancho='79'>
                            <LabelForm>Valores recibidos</LabelForm>
                            <AgGridRender altura='148px' data={this.state.grid_valores_recibidos} columnas={this.state.columnDefs_VR} 
                            gridOptions={this.gridOptionsRecibido} onGridReady={this.onGridReady}/>
                            <div className='flex-container' >
                                <div className='flex-item'>
                                    <LabelSub>Total recibo: {this.state.c_total_recibo.toFixed(2)}</LabelSub>
                                </div>
                                <div className='flex-item'>
                                    <LabelSub>Total recibido: {this.state.total_recibidos}</LabelSub>
                                </div>                                
                                <div className='flex-item'>
                                    <LabelSub>Total retención: {this.state.total_retencion}</LabelSub>
                                </div>
                                <div className='flex-item'>
                                    <LabelSub>Total retención fuera de VA: {this.state.total_retencion_fact_traidas}</LabelSub>
                                </div>
                                <div className='flex-item'>
                                    <BotonLink type="button"  disabled={this.state.boton_distribuir} onClick={this.distribuirRecibido.bind(this)}>Distribuir</BotonLink>
                                </div>
                                <div className='flex-item-ajust'>
                                    <BotonLink type="button"  disabled={this.state.grid_valores_recibidos.length > 0?false:true} onClick={this.modificarValoresRecibidos.bind(this)}>Editar bancos</BotonLink>
                                </div>
                            </div>                                                       
                        </ContenedorGrid>
                        <ContenedorGrid className='col-md-3' ancho='21' margen_izq='0'>
                            <LabelForm>Valores aplicados</LabelForm>
                            <AgGridRender altura='148px' data={this.state.grid_valores_aplicados} columnas={this.state.columnDefs_VA} 
                            gridOptions={this.gridOptionsAplicado} /*onGridReady={this.onGridReady}*//> 
                                <div className='flex-container'>
                                    <div className='flex-item'>
                                        <LabelSub>Total: {this.state.total_aplicacion}</LabelSub>
                                    </div>
                                    <div className='flex-item'>
                                        <LabelSub color={this.state.diferenciaVA > 0?'red':'black'}>Dif. : {this.state.diferenciaVA}</LabelSub>
                                    </div>
                                    <div className='flex-item'>
                                        <BotonLink type="button" disabled={this.state.diferenciaVA > 0?false:true}  onClick={this.completarConNotaCredito.bind(this)} >Completar con N/C</BotonLink>
                                    </div>
                                </div>                         
                        </ContenedorGrid>
                    </Row>                    
                    <Row>
                        <ContainerCol className='col-md-7'>
                            <LabelForm>{(this.props.recibo_estado==='P')?'Documentos pendientes':'Libro diario'}</LabelForm>
                            <AgGridRender altura='128px' data={this.state.grid_docs_pendientes} columnas={(this.props.recibo_estado==='P')?this.state.columnDefs_DP:this.state.columnDefs_LibroDiario} gridOptions={this.gridOptionsPendientes} onGridReady={this.onGridReadyDP}/>
                            <div className='flex-container'>
                                <div className='flex-item' style={(this.props.recibo_estado==='P')?visible:invisible}>                    
                                    <LabelSub>Total saldo: {this.state.total_saldo_recibido_DP}</LabelSub>
                                </div>
                                <div className='flex-item'>
                                    <LabelSub>Total ret.: {this.state.total_ret_DP}</LabelSub>
                                </div>
                                <div className='flex-item'>
                                    <LabelSub>Total aplicado: {this.state.total_aplicado_DP}</LabelSub>
                                </div>                                    
                                <div className='flex-item'>
                                    <BotonLink type="button" disabled={this.state.boton_aplicar_distribucion}  onClick={this.aplicarDistribuirGeneral.bind(this)} >Aplicar distribución</BotonLink>
                                </div>
                            </div>                          
                        </ContainerCol>

                        <ContainerCol className='col-md-5'>
                            <LabelForm>Distribución pago</LabelForm>
                            <AgGridRender altura='128px' data={this.state.grid_distribucionpago} columnas={this.state.columnDefs_DISPG} 
                            gridOptions={this.gridOptionsPago}/>
                                <div className='flex-container'>
                                    <div className='flex-item'>
                                        <LabelSub>Total: {this.state.total_DISPG}</LabelSub>
                                    </div>
                                </div>                           
                        </ContainerCol>

                    </Row>
                    <Row>
                        <div style={(this.state.recibo_estado==='G' && this.state.grid_notas_credito.length > 0)?visible:invisible}>
                            <div className='col-md-4 col-md-offset-8 col-md-pull-8'>
                                <LabelForm>Notas de credito</LabelForm>
                                <AgGridRender altura='80px' data={this.state.grid_notas_credito} columnas={this.state.columnDefs_notas_credito} 
                                gridOptions={this.gridOptionsPago} />
                                <div className='flex-container'>
                                    <div className='flex-item'>
                                        <LabelSub>Total: {this.state.total_ntacredito}</LabelSub>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Row>
                    <Row>                  
                        <ContainerCol className='col-md-12'>
                            <div className="btn-group pull-right">
                                <button type="submit" className='btn btn-primary btn-sm' disabled={this.state.recaudador} onClick={this.AplicarRecaudador}>
                                    <i className="fa fa-floppy-o fa-lg"></i> Guardar
                                </button>
                                <button type="button" className='btn btn-sm' onClick={this.Limpiar}>
                                    <i className="fa fa-trash-o fa-lg"></i> Limpiar
                                </button>
                                <button type='button' className='btn btn-info btn-sm' disabled={this.props.cliente?false:true} onClick={this.impCarteraCliente}>
                                    <i className="fa fa-print fa-lg" aria-hidden="true"/> Imp. Cartera Cliente
                                </button>           
                            </div>
                        </ContainerCol>                  
                    </Row>
                </CuerpoForm>
                <ModalResponsive open={this.state.editarValoresRecibidos} onClose={()=>{this.setState({editarValoresRecibidos: false})}}>              
                    <HeaderForm>
                        <TituloForm>Edición de banco</TituloForm>
                    </HeaderForm>
                    <ContenedorModal>
                        <Row>
                            <ContainerCol className='col-md-12'>                                
                                <ContainerCol className='col-md-6' margen_arriba='5'>
                                    <LabelForm>Banco actual: </LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-md-6 ' margen_arriba='5'>
                                    <ReactSelect options={ this.state.catBancos } disabled={true} value={this.state.catBancosRow_sel} func_onChange={(value)=>{this.setState({catBancosRow_sel: value})}} />
                                </ContainerCol>
                                <ContainerCol className='col-md-6'>
                                    <LabelForm>Banco a cambiar: </LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-md-6 '>
                                    <ReactSelect options={ this.state.catBancos } value={this.state.catBancos_sel} func_onChange={(value)=>{this.setState({catBancos_sel: value})}} />
                                </ContainerCol>
                            </ContainerCol>                            
                        </Row>
                        <Row margen_arriba='10'>                  
                            <ContainerCol className='col-md-12'>
                                <div className="btn-group pull-right">
                                    <button type="submit" className='btn btn-primary btn-sm' disabled={this.state.catBancos_sel===null?true:false} onClick={this.cambiarBancosPorFila}>
                                        <i className="fa fa-floppy-o fa-lg"></i> Cambiar
                                    </button>         
                                </div>
                            </ContainerCol>                  
                        </Row>
                    </ContenedorModal>
                </ModalResponsive>
            </ContenedorForm>
        )
    }
}
const selector = formValueSelector('form_caja01');

FormCaja01 = reduxForm({
    form: 'form_caja01', enableReinitialize: true })(FormCaja01)

FormCaja01 = connect( 
    state => ({
        initialValues: state.inicializacion_form.data,

        Total_aplicados: selector(state, 'Total_aplicados'),
        Total_recibido: selector(state, 'Total_recibido'),
        Total_ret: selector(state, 'Total_ret'),
        Val_aplicados: selector(state, 'Val_aplicados'),
        Val_recibidos: selector(state, 'Val_recibidos'),
        total_recibo: selector(state, 'total_recibo'),        
        fecha_recibo: selector(state, 'fecha_recibo'),        
        Val_pendiente: selector(state, 'Val_pendiente'),
        Total_saldo_p: selector(state, 'Total_saldo_p'),
        ret_exist: selector(state, 'ret_exist'),
        cash_dpto_exist: selector(state, 'cash_dpto_exist'),
        cliente: selector(state, 'cliente'),
        num_ret: selector(state, 'num_ret'),
        observacion_supervisor: selector(state, 'observacion_supervisor'),
        recibo_estado: selector(state, 'estado'),

        //Modal
        user_modal: selector(state, 'user_modal'),
        pass_modal: selector(state, 'pass_modal'),

        //Libro Diario
        Val_libroDiario: selector(state,'Val_LibroDiario'),
        Val_Distribuido: selector(state,'Val_Distribuido'),
        Total_dist: selector(state, 'Total_dist'),

        //NC
        Val_NotasCredito: selector(state, 'Val_NotasCredito'),
        Total_NC: selector(state, 'Total_NC'),

        mensaje: selector(state, 'msg'),
        exist_auditoria: selector (state, 'exist_auditoria'),  
        usuario: state.sesion.valoresSesionForm.Usuario,
        formulario: state.sesion.valoresSesionForm.Formulario,
        permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
        diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias 
    
    }),
    { cargar_Cobranza_a_Editar: cargar_cobranza,
      cargar_ValoresIniciales, cambiar_VisualizacionLoading, 
      generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm
    }
)(FormCaja01)
export default FormCaja01;